(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[30],{

/***/ 46782:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof __webpack_require__.g&&__webpack_require__.g.global===__webpack_require__.g?__webpack_require__.g:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g, true&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map

/***/ }),

/***/ 88160:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dao/[address]",
      function () {
        return __webpack_require__(87727);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _address_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@noahsaso/cosmodal/dist/index.js
var dist = __webpack_require__(46938);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(41469);
// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(76699);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ../../packages/state/index.ts + 18 modules
var state = __webpack_require__(51697);
// EXTERNAL MODULE: ../../packages/stateful/index.ts + 1 modules
var stateful = __webpack_require__(63064);
// EXTERNAL MODULE: ../../packages/stateful/actions/index.tsx + 65 modules
var actions = __webpack_require__(48874);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(46782);
// EXTERNAL MODULE: ../../node_modules/json2csv/dist/json2csv.umd.js
var json2csv_umd = __webpack_require__(33231);
// EXTERNAL MODULE: ../../packages/state/recoil/index.ts + 18 modules
var recoil = __webpack_require__(28753);
// EXTERNAL MODULE: ../../packages/stateless/index.tsx + 492 modules
var stateless = __webpack_require__(57572);
// EXTERNAL MODULE: ../../packages/utils/index.tsx + 27 modules
var utils = __webpack_require__(62413);
// EXTERNAL MODULE: ../../packages/stateful/components/index.tsx + 100 modules
var components = __webpack_require__(67631);
// EXTERNAL MODULE: ../../packages/stateful/hooks/index.ts + 16 modules
var hooks = __webpack_require__(14693);
;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/constants.ts
var API_BASE = "https://retroactive-compensation-cf-worker.dao-dao.workers.dev";
var SIGNATURE_TYPE = "Retroactive Compensation";

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/hooks/usePostRequest.ts



var usePostRequest = function() {
    return (0,hooks/* useCfWorkerAuthPostRequest */.S1)(API_BASE, SIGNATURE_TYPE, (0,stateless/* useDaoInfoContext */.XMV)().chainId).postRequest;
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/atoms.ts

// Increment this to refresh status.
var refreshStatusAtom = (0,es/* atomFamily */.xu)({
    key: "payrollRetroactiveRefreshStatus",
    default: 0
});

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/selectors.ts






var statusSelector = (0,es/* selectorFamily */.CG)({
    key: "payrollRetroactiveStatus",
    get: function(param) {
        var daoAddress = param.daoAddress, walletPublicKey = param.walletPublicKey;
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var get, response, responseBody;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            get = param.get;
                            get(refreshStatusAtom({
                                daoAddress: daoAddress
                            }));
                            _ctx.next = 4;
                            return fetch("".concat(API_BASE, "/").concat(daoAddress, "/").concat(walletPublicKey, "/status"));
                        case 4:
                            response = _ctx.sent;
                            if (!(response.status === 404)) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return", undefined);
                        case 9:
                            if (response.ok) {
                                _ctx.next = 15;
                                break;
                            }
                            _ctx.next = 12;
                            return response.json().catch(function(err) {
                                return {
                                    error: (0,_instanceof/* default */.Z)(err, Error) ? err.message : JSON.stringify(err)
                                };
                            });
                        case 12:
                            responseBody = _ctx.sent;
                            console.error("Failed to fetch retroactive payroll survey status.", response, responseBody);
                            throw new Error("error" in responseBody ? responseBody.error : JSON.stringify(responseBody));
                        case 15:
                            _ctx.next = 17;
                            return response.json();
                        case 17:
                            return _ctx.abrupt("return", _ctx.sent);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    }
});
var listCompletedSurveysSelector = (0,es/* selectorFamily */.CG)({
    key: "listCompletedSurveys",
    get: function(param) {
        var daoAddress = param.daoAddress;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, responseBody, body;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch("".concat(API_BASE, "/").concat(daoAddress, "/list"));
                    case 2:
                        response = _ctx.sent;
                        if (!(response.status === 404)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", undefined);
                    case 7:
                        if (response.ok) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 10;
                        return response.json().catch(function(err) {
                            return {
                                error: (0,_instanceof/* default */.Z)(err, Error) ? err.message : JSON.stringify(err)
                            };
                        });
                    case 10:
                        responseBody = _ctx.sent;
                        console.error("Failed to fetch retroactive payroll survey list.", response, responseBody);
                        throw new Error("error" in responseBody ? responseBody.error : JSON.stringify(responseBody));
                    case 13:
                        _ctx.next = 15;
                        return response.json();
                    case 15:
                        body = _ctx.sent;
                        if (!(!("surveys" in body) || !Array.isArray(body.surveys))) {
                            _ctx.next = 18;
                            break;
                        }
                        throw new Error("Unexpected response from retroactive payroll survey list.");
                    case 18:
                        return _ctx.abrupt("return", body.surveys);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    }
});

// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/Remove.js
var Remove = __webpack_require__(60791);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/Add.js
var Add = __webpack_require__(92252);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(25838);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/utils/createSvgIcon.js + 2 modules
var createSvgIcon = __webpack_require__(39786);
;// CONCATENATED MODULE: ../../node_modules/@mui/icons-material/esm/Ballot.js


/* harmony default export */ var Ballot = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  fillRule: "evenodd",
  d: "M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z"
}), 'Ballot'));
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/DescriptionOutlined.js
var DescriptionOutlined = __webpack_require__(98351);
;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateless/CompletedSurveyRow.tsx






var CompletedSurveyRow = function(param) {
    var _survey = param.survey, name = _survey.name, contributionCount = _survey.contributionCount, contributionsOpenedAt = _survey.contributionsOpenedAt, proposalId = _survey.proposalId, onClick = param.onClick, IconButtonLink = param.IconButtonLink, className = param.className;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var coreAddress = (0,stateless/* useDaoInfoContext */.XMV)().coreAddress;
    var openedAtEpoch = Date.parse(contributionsOpenedAt);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("cursor-pointer rounded-md bg-background-secondary transition hover:bg-background-interactive-hover active:bg-background-interactive-pressed", className),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden h-12 flex-row items-center gap-6 p-3 sm:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "body-text grow truncate",
                        children: name
                    }),
                    !!proposalId && /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Tooltip */.ua7, {
                        title: t("button.goToProposal"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonLink, {
                            Icon: DescriptionOutlined/* default */.Z,
                            href: "/dao/".concat(coreAddress, "/proposals/").concat(proposalId),
                            onClick: // Don't click on row.
                            function(e) {
                                return e.stopPropagation();
                            },
                            size: "sm",
                            variant: "ghost"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-right",
                        children: t("info.numContributors", {
                            count: contributionCount
                        })
                    }),
                    !isNaN(openedAtEpoch) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "caption-text shrink-0 break-words text-right font-mono",
                        children: (0,utils/* formatDate */.p6)(new Date(contributionsOpenedAt))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-between gap-2 rounded-md p-4 text-sm sm:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-start justify-between gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "body-text break-words",
                                children: name
                            }),
                            !!proposalId && /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Tooltip */.ua7, {
                                title: t("button.goToProposal"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonLink, {
                                    Icon: DescriptionOutlined/* default */.Z,
                                    href: "/dao/".concat(coreAddress, "/proposals/").concat(proposalId),
                                    size: "sm",
                                    variant: "ghost"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center justify-between gap-6",
                        children: [
                            !isNaN(openedAtEpoch) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "legend-text shrink-0 break-words font-mono",
                                children: (0,utils/* formatDate */.p6)(new Date(contributionsOpenedAt))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "caption-text grow text-right",
                                children: t("info.numContributors", {
                                    count: contributionCount
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateless/PayrollTab.tsx







var PayrollTab = function(param) {
    var loadingStatus = param.loadingStatus, loadingCompletedSurveys = param.loadingCompletedSurveys, isMember = param.isMember, NewSurveyForm = param.NewSurveyForm, OpenSurveySection = param.OpenSurveySection, downloadCompletedSurvey = param.downloadCompletedSurvey, loadingCompletedSurveyId = param.loadingCompletedSurveyId, loadingMembershipDuringCompletedSurveys = param.loadingMembershipDuringCompletedSurveys, IconButtonLink = param.IconButtonLink;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var coreAddress = (0,stateless/* useDaoInfoContext */.XMV)().coreAddress;
    var ref = (0,react.useState)(false), showCreate = ref[0], setShowCreate = ref[1];
    // Can create survey if member of DAO and there does not exist a current
    // survey.
    var canCreateSurvey = isMember && !loadingStatus.loading && !loadingStatus.data;
    // Subtitle status.
    var subtitleStatus = !loadingStatus.loading && !loadingStatus.data ? t("info.noActiveCompensationCycle") : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center justify-between gap-8 border-b border-border-secondary pb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row flex-wrap items-center gap-x-4 gap-y-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "title-text text-text-body",
                                children: t("title.retroactiveCompensation")
                            }),
                            subtitleStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "secondary-text",
                                children: subtitleStatus
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Tooltip */.ua7, {
                        title: !isMember ? t("error.mustBeMemberToCreateCompensationCycle") : !loadingStatus.loading && loadingStatus.data ? t("error.cannotCreateCompensationCycleAlreadyActive") : undefined,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Button */.zxk, {
                            className: "shrink-0",
                            disabled: !canCreateSurvey,
                            onClick: function() {
                                return setShowCreate(function(c) {
                                    return !c;
                                });
                            },
                            children: canCreateSurvey && showCreate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {
                                        className: "!h-4 !w-4"
                                    }),
                                    t("button.cancel")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                        className: "!h-4 !w-4"
                                    }),
                                    t("button.newCompensationCycle")
                                ]
                            })
                        })
                    })
                ]
            }),
            loadingStatus.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Loader */.aNw, {
                fill: false
            }) : !loadingStatus.data ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSurveySection, {
                status: loadingStatus.data
            }),
            canCreateSurvey && showCreate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewSurveyForm, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "link-text ml-2 flex flex-row items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                                className: "!h-4 !w-4 text-icon-primary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-text-secondary",
                                children: t("title.history")
                            })
                        ]
                    }),
                    loadingCompletedSurveys.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Loader */.aNw, {
                        fill: false
                    }) : loadingCompletedSurveys.data.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-1",
                        children: loadingCompletedSurveys.data.map(function(survey, index) {
                            var wasMemberDuringSurvey = !loadingMembershipDuringCompletedSurveys.loading && Number(loadingMembershipDuringCompletedSurveys.data[index].power) > 0;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompletedSurveyRow, {
                                IconButtonLink: IconButtonLink,
                                className: (0,clsx_m/* default */.Z)(// If survey is loading, animate pulse.
                                loadingCompletedSurveyId === survey.id && "animate-pulse", // If was not a member and no proposal, disable pointer
                                // events since we can't do anything.
                                !wasMemberDuringSurvey && !survey.proposalId && "pointer-events-none"),
                                onClick: function() {
                                    return wasMemberDuringSurvey ? downloadCompletedSurvey(survey) : survey.proposalId && window.open("/dao/".concat(coreAddress, "/proposals/").concat(survey.proposalId));
                                },
                                survey: survey
                            }, survey.id);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* NoContent */.dJ$, {
                        Icon: Ballot,
                        actionNudge: t("info.createFirstOneQuestion"),
                        body: t("info.noCompletedCyclesYet"),
                        buttonLabel: t("button.newCompensationCycle"),
                        onClick: canCreateSurvey && !showCreate ? function() {
                            return setShowCreate(true);
                        } : undefined
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../packages/stateful/voting-module-adapter/react/hooks/useCw20GovernanceTokenInfoResponseIfExists.ts
var useCw20GovernanceTokenInfoResponseIfExists = __webpack_require__(86979);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(94106);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/Close.js
var Close = __webpack_require__(36269);
;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateless/NewAttribute.tsx






var NewAttribute = function(param) {
    var attributeIndex = param.index, onRemove = param.onRemove, nativeDenoms = param.nativeDenoms, cw20TokenInfos = param.cw20TokenInfos;
    var ref, ref1, ref2, ref3;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref4 = (0,index_esm/* useFormContext */.Gc)(), control = ref4.control, register = ref4.register, errors = ref4.formState.errors, setValue = ref4.setValue, watch = ref4.watch;
    var ref5 = (0,index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "attributes.".concat(attributeIndex, ".tokens")
    }), appendToken = ref5.append, removeToken = ref5.remove, tokens = ref5.fields;
    var ref6, ref7;
    // Returns the decimals for the given native denom or CW20 address.
    var getDecimalsForDenomOrAddress = function(denomOrAddress) {
        var ref, ref1;
        return (ref7 = (ref6 = (ref = cw20TokenInfos.find(function(param) {
            var address = param.address;
            return address === denomOrAddress;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.info) === null || ref1 === void 0 ? void 0 : ref1.decimals) !== null && ref6 !== void 0 ? ref6 : (0,utils/* nativeTokenDecimals */.OZ)(denomOrAddress)) !== null && ref7 !== void 0 ? ref7 : 0;
    };
    var _symbol;
    // Returns a label for the given native denom or CW20 address.
    var getLabelForDenomOrAddress = function(denomOrAddress) {
        var ref;
        return (_symbol = (ref = cw20TokenInfos.find(function(param) {
            var address = param.address;
            return address === denomOrAddress;
        })) === null || ref === void 0 ? void 0 : ref.info.symbol) !== null && _symbol !== void 0 ? _symbol : (0,utils/* nativeTokenLabel */.S0)(denomOrAddress);
    };
    // Combine tokens into readable list.
    var stringifiedTokens = (watch("attributes.".concat(attributeIndex, ".tokens")) || []).filter(function(param) {
        var amount = param.amount;
        return amount && !isNaN(Number(amount));
    }).map(function(param) {
        var amount = param.amount, denomOrAddress = param.denomOrAddress;
        return "".concat(Number(amount).toLocaleString(undefined, {
            maximumFractionDigits: getDecimalsForDenomOrAddress(denomOrAddress)
        }), " $").concat(getLabelForDenomOrAddress(denomOrAddress));
    });
    var stringifiedTokensList = stringifiedTokens.length > 2 ? stringifiedTokens.slice(0, -2).join(", ") + ", " + stringifiedTokens.slice(-2).join(", and ") : stringifiedTokens.join(" and ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col rounded-lg bg-background-tertiary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-y-2 gap-x-4 py-4 px-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputLabel */.AZs, {
                                name: t("form.attributeName")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* IconButton */.hU, {
                                Icon: Close/* default */.Z,
                                onClick: onRemove,
                                size: "sm",
                                variant: "ghost"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextInput */.oil, {
                                error: (ref = errors.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref[attributeIndex]) === null || ref1 === void 0 ? void 0 : ref1.name,
                                fieldName: "attributes.".concat(attributeIndex, ".name"),
                                placeholder: t("form.attributeNamePlaceholder"),
                                register: register,
                                validation: [
                                    utils/* validateRequired */.QK
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                error: (ref2 = errors.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[attributeIndex]) === null || ref3 === void 0 ? void 0 : ref3.name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2 border-t border-border-secondary py-4 px-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "primary-text text-text-body",
                        children: t("form.whatDoWeDistributeQuestion")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-1",
                        children: tokens.map(function(token, tokenIndex) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                            var denomOrAddressFieldName = "attributes.".concat(attributeIndex, ".tokens.").concat(tokenIndex, ".denomOrAddress");
                            var denomOrAddress = watch(denomOrAddressFieldName);
                            var decimals = getDecimalsForDenomOrAddress(denomOrAddress);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-2 rounded-lg bg-background-tertiary p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* NumberInput */.Y2U, {
                                        containerClassName: "grow",
                                        error: errors === null || errors === void 0 ? void 0 : (ref = errors.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref[attributeIndex]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tokens) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[tokenIndex]) === null || ref3 === void 0 ? void 0 : ref3.amount,
                                        fieldName: "attributes.".concat(attributeIndex, ".tokens.").concat(tokenIndex, ".amount"),
                                        onMinus: function() {
                                            return setValue("attributes.".concat(attributeIndex, ".tokens.").concat(tokenIndex, ".amount"), Math.max((Number(watch("attributes.".concat(attributeIndex, ".tokens.").concat(tokenIndex, ".amount"))) || 0) - 1, Math.pow(10, -decimals)).toString());
                                        },
                                        onPlus: function() {
                                            return setValue("attributes.".concat(attributeIndex, ".tokens.").concat(tokenIndex, ".amount"), Math.max((Number(watch("attributes.".concat(attributeIndex, ".tokens.").concat(tokenIndex, ".amount"))) || 0) + 1, Math.pow(10, -decimals)).toString());
                                        },
                                        register: register,
                                        sizing: "auto",
                                        step: Math.pow(10, -decimals),
                                        validation: [
                                            utils/* validateRequired */.QK,
                                            utils/* validatePositive */.yZ
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* SelectInput */.lqs, {
                                        defaultValue: utils/* NATIVE_DENOM */.lq,
                                        error: errors === null || errors === void 0 ? void 0 : (ref4 = errors.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[attributeIndex]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.tokens) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[tokenIndex]) === null || ref7 === void 0 ? void 0 : ref7.denomOrAddress,
                                        fieldName: denomOrAddressFieldName,
                                        register: register,
                                        children: [
                                            nativeDenoms.map(function(denom) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    value: denom,
                                                    children: [
                                                        "$",
                                                        (0,utils/* nativeTokenLabel */.S0)(denom)
                                                    ]
                                                }, denom);
                                            }),
                                            cw20TokenInfos.map(function(param) {
                                                var address = param.address, symbol = param.info.symbol;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    value: address,
                                                    children: [
                                                        "$",
                                                        symbol
                                                    ]
                                                }, address);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* IconButton */.hU, {
                                            Icon: Close/* default */.Z,
                                            onClick: function() {
                                                return removeToken(tokenIndex);
                                            },
                                            size: "sm",
                                            variant: "ghost"
                                        })
                                    })
                                ]
                            }, token.id);
                        })
                    }),
                    stringifiedTokens.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "legend-text",
                        children: t("info.tokensWillBeSplitAmongContributors", {
                            tokens: stringifiedTokensList
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* Button */.zxk, {
                        className: "self-start",
                        onClick: function() {
                            return appendToken({
                                denomOrAddress: nativeDenoms[0]
                            });
                        },
                        variant: "ghost",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                className: "!h-4 !w-4"
                            }),
                            t("button.addToken")
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateless/NewSurveyForm.tsx












var NewSurveyForm = function(_param) {
    var onCreate = _param.onCreate, loading = _param.loading, newAttributeProps = (0,_object_without_properties/* default */.Z)(_param, [
        "onCreate",
        "loading"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            attributes: [
                {
                    name: "",
                    tokens: []
                }, 
            ]
        }
    });
    var watch = formMethods.watch, control = formMethods.control, register = formMethods.register, handleSubmit = formMethods.handleSubmit, errors = formMethods.formState.errors;
    var contributionsOpenAt = watch("contributionsOpenAt");
    var contributionsCloseRatingsOpenAt = watch("contributionsCloseRatingsOpenAt");
    var ratingsCloseAt = watch("ratingsCloseAt");
    var ref = (0,index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "attributes"
    }), appendAttribute = ref.append, removeAttribute = ref.remove, attributes = ref.fields;
    var onFormRef = (0,react.useCallback)(function(ref) {
        if (ref) {
            ref.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: "flex flex-col gap-4",
            onSubmit: handleSubmit(onCreate),
            ref: onFormRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "title-text text-text-body",
                    children: t("title.newCompensationCycle")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputLabel */.AZs, {
                            name: t("form.compensationCycleName")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextInput */.oil, {
                                    error: errors.name,
                                    fieldName: "name",
                                    placeholder: t("form.compensationCycleNamePlaceholder"),
                                    register: register,
                                    validation: [
                                        utils/* validateRequired */.QK
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                    error: errors.name
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "primary-text -mb-2 text-text-body",
                    children: t("title.publicSubmissions")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-4 rounded-lg bg-background-tertiary p-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-4 sm:flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grow basis-0 space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-end gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputLabel */.AZs, {
                                                    name: t("form.openDate")
                                                }),
                                                !!contributionsOpenAt && !isNaN(Date.parse(contributionsOpenAt)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "caption-text",
                                                    children: (0,utils/* formatDateTimeTz */.F)(new Date(contributionsOpenAt))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextInput */.oil, {
                                                    error: errors.contributionsOpenAt,
                                                    fieldName: "contributionsOpenAt",
                                                    // eslint-disable-next-line i18next/no-literal-string
                                                    placeholder: "YYYY-MM-DD HH:mm",
                                                    register: register,
                                                    validation: [
                                                        utils/* validateRequired */.QK,
                                                        (0,utils/* makeValidateDate */._B)(t)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                                    error: errors.contributionsOpenAt
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grow basis-0 space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-end gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputLabel */.AZs, {
                                                    name: t("form.closeDate")
                                                }),
                                                !!contributionsCloseRatingsOpenAt && !isNaN(Date.parse(contributionsCloseRatingsOpenAt)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "caption-text",
                                                    children: (0,utils/* formatDateTimeTz */.F)(new Date(contributionsCloseRatingsOpenAt))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextInput */.oil, {
                                                    error: errors.contributionsCloseRatingsOpenAt,
                                                    fieldName: "contributionsCloseRatingsOpenAt",
                                                    // eslint-disable-next-line i18next/no-literal-string
                                                    placeholder: "YYYY-MM-DD HH:mm",
                                                    register: register,
                                                    validation: [
                                                        utils/* validateRequired */.QK,
                                                        (0,utils/* makeValidateDate */._B)(t),
                                                        // Ensure close date is after open date.
                                                        function() {
                                                            return(// Valid if dates not yet available.
                                                            !(contributionsOpenAt && !isNaN(Date.parse(contributionsOpenAt)) && contributionsCloseRatingsOpenAt && !isNaN(Date.parse(contributionsCloseRatingsOpenAt))) || new Date(contributionsCloseRatingsOpenAt) > new Date(contributionsOpenAt) || t("error.closeDateMustBeAfterOpenDate"));
                                                        }, 
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                                    error: errors.contributionsCloseRatingsOpenAt
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* InputLabel */.AZs, {
                                    children: [
                                        t("form.instructions"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-text-tertiary",
                                            children: [
                                                " – ",
                                                t("info.supportsMarkdownFormat")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextAreaInput */.Fz4, {
                                            error: errors.contributionInstructions,
                                            fieldName: "contributionInstructions",
                                            placeholder: t("form.contributionInstructionsPlaceholder"),
                                            register: register,
                                            rows: 5,
                                            validation: [
                                                utils/* validateRequired */.QK
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                            error: errors.contributionInstructions
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "primary-text -mb-2 text-text-body",
                    children: t("title.daoRatings")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-4 rounded-lg bg-background-tertiary p-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-4 sm:flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grow basis-0 space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-end gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputLabel */.AZs, {
                                                    name: t("form.openDate")
                                                }),
                                                !!contributionsCloseRatingsOpenAt && !isNaN(Date.parse(contributionsCloseRatingsOpenAt)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "caption-text",
                                                    children: (0,utils/* formatDateTimeTz */.F)(new Date(contributionsCloseRatingsOpenAt))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputThemedText */.i9r, {
                                            className: (0,clsx_m/* default */.Z)(// Explicitly set height so it doesn't shrink when empty.
                                            "h-10", !contributionsCloseRatingsOpenAt && "text-text-tertiary"),
                                            children: contributionsCloseRatingsOpenAt || t("form.sameAsPublicSubmissionCloseDate")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grow basis-0 space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-end gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputLabel */.AZs, {
                                                    name: t("form.closeDate")
                                                }),
                                                !!ratingsCloseAt && !isNaN(Date.parse(ratingsCloseAt)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "caption-text",
                                                    children: (0,utils/* formatDateTimeTz */.F)(new Date(ratingsCloseAt))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextInput */.oil, {
                                                    error: errors.ratingsCloseAt,
                                                    fieldName: "ratingsCloseAt",
                                                    // eslint-disable-next-line i18next/no-literal-string
                                                    placeholder: "YYYY-MM-DD HH:mm",
                                                    register: register,
                                                    validation: [
                                                        utils/* validateRequired */.QK,
                                                        (0,utils/* makeValidateDate */._B)(t),
                                                        // Ensure close date is after open date.
                                                        function() {
                                                            return(// Valid if dates not yet available.
                                                            !(contributionsCloseRatingsOpenAt && !isNaN(Date.parse(contributionsCloseRatingsOpenAt)) && ratingsCloseAt && !isNaN(Date.parse(ratingsCloseAt))) || new Date(ratingsCloseAt) > new Date(contributionsCloseRatingsOpenAt) || t("error.closeDateMustBeAfterOpenDate"));
                                                        }, 
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                                    error: errors.ratingsCloseAt
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* InputLabel */.AZs, {
                                    children: [
                                        t("form.instructions"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-text-tertiary",
                                            children: [
                                                " – ",
                                                t("info.supportsMarkdownFormat")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextAreaInput */.Fz4, {
                                            error: errors.ratingInstructions,
                                            fieldName: "ratingInstructions",
                                            placeholder: t("form.ratingInstructionsPlaceholder"),
                                            register: register,
                                            rows: 5,
                                            validation: [
                                                utils/* validateRequired */.QK
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                            error: errors.ratingInstructions
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "primary-text text-text-body",
                            children: t("form.contributionAttributes")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "secondary-text max-w-prose",
                            children: t("form.contributionAttributesDescription")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4 space-y-2",
                            children: attributes.map(function(attribute, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewAttribute, (0,_object_spread/* default */.Z)({
                                    index: index,
                                    onRemove: function() {
                                        return removeAttribute(index);
                                    }
                                }, newAttributeProps), attribute.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* Button */.zxk, {
                            className: "self-start",
                            onClick: function() {
                                return appendAttribute({
                                    name: "",
                                    tokens: []
                                });
                            },
                            variant: "ghost",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    className: "!h-4 !w-4"
                                }),
                                t("button.addAttribute")
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* Button */.zxk, {
                    className: "mb-10 self-end",
                    loading: loading,
                    type: "submit",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                            className: "!h-4 !w-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("button.create")
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateful/NewSurveyForm.tsx



















var NewSurveyForm_NewSurveyForm = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,stateless/* useDaoInfoContext */.XMV)(), coreAddress = ref.coreAddress, chainId = ref.chainId;
    var ref1;
    // Get CW20 governance token address from voting module adapter if exists, so
    // we can make sure to load it with all cw20 balances, even if it has not been
    // explicitly added to the DAO.
    var governanceTokenAddress = ((ref1 = (0,useCw20GovernanceTokenInfoResponseIfExists/* useCw20GovernanceTokenInfoResponseIfExists */.Y)()) !== null && ref1 !== void 0 ? ref1 : {}).governanceTokenAddress;
    var cw20TokenInfos = (0,es/* useRecoilValue */.sJ)(recoil/* DaoCoreV2Selectors.allCw20InfosSelector */.A2.allCw20InfosSelector({
        contractAddress: coreAddress,
        chainId: chainId,
        governanceTokenAddress: governanceTokenAddress
    }));
    // This needs to be loaded via a cached loadable to avoid displaying a loader
    // when this data updates on a schedule. Manually trigger a suspense loader
    // the first time when the initial data is still loading.
    var nativeBalancesLoadable = (0,utils/* loadableToLoadingData */.AM)((0,stateless/* useCachedLoadable */.VwH)((0,recoil/* nativeBalancesSelector */._e)({
        address: coreAddress,
        chainId: chainId
    })), []);
    var postRequest = usePostRequest();
    var setRefreshStatus = (0,es/* useSetRecoilState */.Zl)(refreshStatusAtom({
        daoAddress: coreAddress
    }));
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var onCreate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(surveyData) {
            var survey;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!nativeBalancesLoadable.loading) {
                            _ctx.next = 3;
                            break;
                        }
                        react_hot_toast_esm/* default.error */.ZP.error(t("error.loadingData"));
                        return _ctx.abrupt("return");
                    case 3:
                        setLoading(true);
                        _ctx.prev = 4;
                        survey = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, surveyData), {
                            // Convert date strings to dates and back, to ensure they are in the
                            // local timezone.
                            contributionsOpenAt: new Date(surveyData.contributionsOpenAt).toISOString(),
                            contributionsCloseRatingsOpenAt: new Date(surveyData.contributionsCloseRatingsOpenAt).toISOString(),
                            ratingsCloseAt: new Date(surveyData.ratingsCloseAt).toISOString(),
                            // Split up cw20 and native tokens, and convert amount decimals.
                            attributes: surveyData.attributes.map(function(_param) {
                                var tokens = _param.tokens, attribute = (0,_object_without_properties/* default */.Z)(_param, [
                                    "tokens"
                                ]);
                                var nativeTokens = [];
                                var cw20Tokens = [];
                                tokens.forEach(function(param) {
                                    var denomOrAddress = param.denomOrAddress, amount = param.amount;
                                    var ref, ref1;
                                    var nativeDecimals = (ref = nativeBalancesLoadable.data.find(function(param) {
                                        var denom = param.denom;
                                        return denom === denomOrAddress;
                                    })) === null || ref === void 0 ? void 0 : ref.decimals;
                                    var cw20Decimals = (ref1 = cw20TokenInfos.find(function(param) {
                                        var address = param.address;
                                        return address === denomOrAddress;
                                    })) === null || ref1 === void 0 ? void 0 : ref1.info.decimals;
                                    if (cw20Decimals !== undefined) {
                                        cw20Tokens.push({
                                            address: denomOrAddress,
                                            amount: (0,utils/* convertDenomToMicroDenomWithDecimals */.M4)(amount, cw20Decimals).toString()
                                        });
                                    } else if (nativeDecimals !== undefined) {
                                        nativeTokens.push({
                                            denom: denomOrAddress,
                                            amount: (0,utils/* convertDenomToMicroDenomWithDecimals */.M4)(amount, nativeDecimals).toString()
                                        });
                                    } else {
                                        // Should never happen, but just in case.
                                        throw new Error("Could not find decimals for token with denom or address '".concat(denomOrAddress, "'."));
                                    }
                                });
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attribute), {
                                    nativeTokens: nativeTokens,
                                    cw20Tokens: cw20Tokens
                                });
                            })
                        });
                        _ctx.next = 8;
                        return postRequest("/".concat(coreAddress), {
                            survey: survey
                        });
                    case 8:
                        react_hot_toast_esm/* default.success */.ZP.success(t("success.compensationCycleCreated"));
                        // Reload status on success.
                        setRefreshStatus(function(id) {
                            return id + 1;
                        });
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](4);
                        console.error(_ctx.t0);
                        react_hot_toast_esm/* default.error */.ZP.error((0,_instanceof/* default */.Z)(_ctx.t0, Error) ? _ctx.t0.message : JSON.stringify(_ctx.t0));
                    case 16:
                        _ctx.prev = 16;
                        setLoading(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    12,
                    16,
                    19
                ]
            ]);
        }));
        return function(surveyData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        coreAddress,
        cw20TokenInfos,
        nativeBalancesLoadable,
        postRequest,
        setRefreshStatus,
        t, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SuspenseLoader */.yI, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Loader */.aNw, {}),
        forceFallback: // Manually trigger since we are using a cached loadable but want to
        // wait for this. We use the loadable to prevent re-rendering when the
        // data is updated on a schedule.
        nativeBalancesLoadable.loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewSurveyForm, {
            cw20TokenInfos: cw20TokenInfos,
            loading: loading,
            nativeDenoms: nativeBalancesLoadable.loading ? [] : nativeBalancesLoadable.data.map(function(param) {
                var denom = param.denom;
                return denom;
            }),
            onCreate: onCreate
        })
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/types.ts
var SurveyStatus;
(function(SurveyStatus) {
    SurveyStatus["Inactive"] = "inactive";
    SurveyStatus["AcceptingContributions"] = "accepting_contributions";
    SurveyStatus["AcceptingRatings"] = "accepting_ratings";
    SurveyStatus["AwaitingCompletion"] = "awaiting_completion";
    SurveyStatus["Complete"] = "complete";
})(SurveyStatus || (SurveyStatus = {}));

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/utils.ts



// Distribute compensation per survey attribute among the contributions
// according to the average ratings. Output array matches the order of
// contributonIds input.
var computeCompensation = function(contributionIds, ratings, surveyAttributes) {
    // Compute average of ratings for contributions for each attribute.
    var contributionsWithAverageRatings = contributionIds.map(function(contributionId) {
        // Each item is an array of attribute ratings for this contributor. The
        // order of attributes matches the attribute order in the survey.
        var attributeRatings = ratings.filter(function(rating) {
            return rating.contributionId === contributionId;
        }).map(function(rating) {
            return rating.attributes;
        });
        // Average attribute rating for each attribute. If the ratings were
        // [50, 100], the average is 75. If the ratings were [null, 50], the
        // average is 50. If the ratings were [null, null], the average is 0.
        var averageAttributeRatings = surveyAttributes.map(function(_, attributeIndex) {
            var nonAbstainRatings = attributeRatings.map(function(ratings) {
                return ratings[attributeIndex];
            }).filter(function(rating) {
                return typeof rating === "number";
            });
            // If all ratings are abstain, return 0.
            return nonAbstainRatings.length === 0 ? 0 : nonAbstainRatings.reduce(function(sum, rating) {
                return sum + rating;
            }, 0) / nonAbstainRatings.length;
        });
        return averageAttributeRatings;
    });
    // Compute total of averages for each attribute.
    var totalsOfAverages = surveyAttributes.map(function(_, attributeIndex) {
        return contributionsWithAverageRatings.reduce(function(sum, averageAttributeRatings) {
            return sum + averageAttributeRatings[attributeIndex];
        }, 0);
    });
    // Compute compensation for each contribution per attribute.
    var compensationPerContribution = contributionIds.map(function(contributionId, contributionIndex) {
        var averageRatingPerAttribute = contributionsWithAverageRatings[contributionIndex];
        // Compute compensation for each attribute.
        var compensationPerAttribute = surveyAttributes.map(function(attribute, attributeIndex) {
            var averageRating = averageRatingPerAttribute[attributeIndex];
            var totalOfAverages = totalsOfAverages[attributeIndex];
            var proportionalCompensation = totalOfAverages === 0 ? 0 : averageRating / totalOfAverages;
            var nativeTokens = attribute.nativeTokens.map(function(_param) {
                var amount = _param.amount, token = (0,_object_without_properties/* default */.Z)(_param, [
                    "amount"
                ]);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, token), {
                    amount: Math.floor(Number(amount) * proportionalCompensation).toString()
                });
            });
            var cw20Tokens = attribute.cw20Tokens.map(function(_param) {
                var amount = _param.amount, token = (0,_object_without_properties/* default */.Z)(_param, [
                    "amount"
                ]);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, token), {
                    amount: Math.floor(Number(amount) * proportionalCompensation).toString()
                });
            });
            return {
                averageRating: averageRating,
                nativeTokens: nativeTokens,
                cw20Tokens: cw20Tokens
            };
        });
        return {
            contributionId: contributionId,
            compensationPerAttribute: compensationPerAttribute
        };
    });
    return compensationPerContribution;
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateless/OpenSurveySection.tsx







var OpenSurveySection = function(param) {
    var _status = param.status, contribution = _status.contribution, rated = _status.rated, _survey = _status.survey, status = _survey.status, name = _survey.name, contributionsOpenAt = _survey.contributionsOpenAt, contributionsCloseRatingsOpenAt = _survey.contributionsCloseRatingsOpenAt, onClick = param.onClick, loading = param.loading, connected = param.connected, isMember = param.isMember, tooltip = param.tooltip;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var sectionTitleKey = status === SurveyStatus.Inactive ? "title.upcoming" : status === SurveyStatus.AcceptingContributions ? "title.acceptingSubmissions" : "info.waitingForRateAndPropose";
    // Display upcoming date first, then date when contributions close. Even
    // during processing, show the date when contributions closed.
    var date = status === SurveyStatus.Inactive ? t("info.opensAtDate", {
        date: (0,utils/* formatDateTimeTz */.F)(new Date(contributionsOpenAt))
    }) : status === SurveyStatus.AcceptingContributions ? t("info.closesAtDate", {
        date: (0,utils/* formatDateTimeTz */.F)(new Date(contributionsCloseRatingsOpenAt))
    }) : t("info.closedAtDate", {
        date: (0,utils/* formatDateTimeTz */.F)(new Date(contributionsCloseRatingsOpenAt))
    });
    var submitted = connected && (!isMember && !!contribution || isMember && (status === SurveyStatus.AcceptingContributions ? !!contribution : status === SurveyStatus.AcceptingRatings ? rated : false));
    var canPerformAction = connected && (status === SurveyStatus.AcceptingContributions || isMember && (status === SurveyStatus.AcceptingRatings || status === SurveyStatus.AwaitingCompletion));
    // Don't show if wallet not connected or inactive (upcoming).
    var statusDisplay = connected && status !== SurveyStatus.Inactive && /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* ProposalWalletVote */.xVq, {
        className: (0,clsx_m/* default */.Z)("!w-auto ring-2 ring-inset", submitted ? "text-text-body ring-component-badge-valid" : canPerformAction ? "text-text-body ring-component-badge-brand" : "text-text-tertiary ring-border-secondary"),
        label: submitted ? t("info.submitted") : canPerformAction ? t("info.pending") : t("info.noSubmission"),
        showBadge: // True when isMember and status is awaiting completion, since submitted
        // is set to false.
        !submitted && canPerformAction
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "link-text ml-2 flex flex-row items-center gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                        className: "!h-4 !w-4 text-icon-primary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-text-secondary",
                        children: t(sectionTitleKey)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Tooltip */.ua7, {
                title: tooltip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("rounded-md bg-background-secondary", onClick && "cursor-pointer transition hover:bg-background-interactive-hover active:bg-background-interactive-pressed", loading && "animate-pulse"),
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden h-12 flex-row items-center gap-6 p-3 sm:flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "body-text grow truncate",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "caption-text shrink-0 break-words text-right font-mono",
                                    children: date
                                }),
                                statusDisplay
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-between gap-2 rounded-md p-4 text-sm sm:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row items-start justify-between gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "body-text break-words",
                                            children: name
                                        }),
                                        statusDisplay
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row items-center justify-between gap-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "caption-text shrink-0 break-words text-right font-mono",
                                        children: date
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../node_modules/@mui/icons-material/esm/Publish.js


/* harmony default export */ var Publish = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
}), 'Publish'));
;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateless/ContributionForm.tsx







var ContributionForm = function(param) {
    var _status = param.status, survey = _status.survey, existingContribution = _status.contribution, onSubmit = param.onSubmit, loading = param.loading, profile = param.profile, ProfileDisplay = param.ProfileDisplay;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            contribution: existingContribution || ""
        }
    }), register = ref.register, handleSubmit = ref.handleSubmit, errors = ref.formState.errors;
    var contributed = !!existingContribution;
    var dateText = survey.status === SurveyStatus.Inactive ? t("info.intakeOpensAtAndClosesAt", {
        openDate: (0,utils/* formatDateTimeTz */.F)(new Date(survey.contributionsOpenAt)),
        closeDate: (0,utils/* formatDateTimeTz */.F)(new Date(survey.contributionsCloseRatingsOpenAt))
    }) : t("info.intakeClosesAt", {
        date: (0,utils/* formatDateTimeTz */.F)(new Date(survey.contributionsCloseRatingsOpenAt))
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: "flex grow flex-col gap-6",
        onSubmit: handleSubmit(function(param) {
            var contribution = param.contribution;
            return onSubmit(contribution);
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden max-w-prose space-y-1 break-words lg:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "hero-text",
                        children: survey.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "caption-text italic",
                        children: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto flex max-w-prose flex-col gap-6 lg:mx-0 lg:max-w-full lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-1 break-words lg:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "hero-text",
                                children: survey.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "caption-text italic",
                                children: dateText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* MarkdownPreview */.D, {
                        className: "min-w-0",
                        markdown: survey.contributionInstructions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex grow flex-col gap-4 pb-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "primary-text text-text-body",
                                        children: t("title.you")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDisplay, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "caption-text italic",
                                        children: t("info.profileExplanation")
                                    }),
                                    !profile.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "caption-text text-text-interactive-error",
                                        children: t("error.compensationCycleNeedsProfileName")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextAreaInput */.Fz4, {
                                        error: errors.contribution,
                                        fieldName: "contribution",
                                        placeholder: t("form.iContributedPlaceholder"),
                                        register: register,
                                        rows: 10,
                                        validation: [
                                            utils/* validateRequired */.QK
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                        error: errors.contribution
                                    })
                                ]
                            }),
                            contributed && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "caption-text self-end text-right text-text-interactive-valid",
                                children: t("form.contributionSubmitted")
                            }),
                            survey.status === SurveyStatus.Inactive && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "caption-text self-end text-right text-text-interactive-error",
                                children: t("info.intakeOpensAt", {
                                    date: (0,utils/* formatDateTimeTz */.F)(new Date(survey.contributionsOpenAt))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Tooltip */.ua7, {
                                title: survey.status === SurveyStatus.Inactive ? t("info.intakeOpensAt", {
                                    date: (0,utils/* formatDateTimeTz */.F)(new Date(survey.contributionsOpenAt))
                                }) : !profile.name ? t("error.compensationCycleNeedsProfileName") : undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* Button */.zxk, {
                                    className: "self-end",
                                    disabled: survey.status === SurveyStatus.Inactive || !profile.name,
                                    loading: loading,
                                    type: "submit",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: contributed ? t("button.update") : t("button.submit")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Publish, {
                                            className: "!h-4 !w-4"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateful/ContributionForm.tsx
















var ContributionForm_ContributionForm = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,stateless/* useDaoInfoContext */.XMV)(), coreAddress = ref.coreAddress, chainId = ref.chainId;
    var ref1 = (0,dist.useWallet)(chainId), tmp = ref1.address, walletAddress = tmp === void 0 ? "" : tmp, walletPublicKey = ref1.publicKey;
    var walletProfile = (0,hooks/* useProfile */.Un)({
        address: walletAddress,
        walletHexPublicKey: walletPublicKey === null || walletPublicKey === void 0 ? void 0 : walletPublicKey.hex,
        chainId: chainId
    });
    var postRequest = usePostRequest();
    var statusLoadable = (0,stateless/* useCachedLoadable */.VwH)((walletPublicKey === null || walletPublicKey === void 0 ? void 0 : walletPublicKey.hex) ? statusSelector({
        daoAddress: coreAddress,
        walletPublicKey: walletPublicKey.hex
    }) : undefined);
    var setRefreshStatus = (0,es/* useSetRecoilState */.Zl)(refreshStatusAtom({
        daoAddress: coreAddress
    }));
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contribution) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return postRequest("/".concat(coreAddress, "/contribution"), {
                            contribution: contribution
                        });
                    case 4:
                        react_hot_toast_esm/* default.success */.ZP.success(t("success.contributionSubmitted"));
                        // Reload status on success.
                        setRefreshStatus(function(id) {
                            return id + 1;
                        });
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                        react_hot_toast_esm/* default.error */.ZP.error((0,_instanceof/* default */.Z)(_ctx.t0, Error) ? _ctx.t0.message : JSON.stringify(_ctx.t0));
                    case 12:
                        _ctx.prev = 12;
                        setLoading(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8,
                    12,
                    15
                ]
            ]);
        }));
        return function(contribution) {
            return _ref.apply(this, arguments);
        };
    }(), [
        coreAddress,
        postRequest,
        setRefreshStatus,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SuspenseLoader */.yI, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Loader */.aNw, {}),
        forceFallback: statusLoadable.state === "loading" || walletProfile.loading,
        children: statusLoadable.state === "hasValue" && !!statusLoadable.contents && !walletProfile.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContributionForm, {
            ProfileDisplay: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* ProfileDisplay */.Y$j, {
                    address: walletAddress,
                    loadingProfile: walletProfile
                });
            },
            loading: loading || statusLoadable.updating,
            onSubmit: onSubmit,
            profile: walletProfile.data,
            status: statusLoadable.contents
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/VisibilityOff.js
var VisibilityOff = __webpack_require__(76901);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/Visibility.js
var Visibility = __webpack_require__(16366);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/GavelRounded.js
var GavelRounded = __webpack_require__(36775);
;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateless/ProposalCreationForm.tsx













var ProposalCreationForm = function(param) {
    var survey = param.status.survey, completeRatings = param.completeRatings, onComplete = param.onComplete, loading = param.loading, ProfileDisplay = param.ProfileDisplay, cw20TokenInfos = param.cw20TokenInfos, prices = param.prices, walletAddress = param.walletAddress, profile = param.profile;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    // Convert cw20TokenInfos into map of token addresses to token info.
    var cw20TokenInfosMap = (0,react.useMemo)(function() {
        return cw20TokenInfos.reduce(function(acc, tokenInfo) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, tokenInfo.address, tokenInfo));
        }, {});
    }, [
        cw20TokenInfos
    ]);
    // Convert prices into map of token to price.
    var pricesMap = (0,react.useMemo)(function() {
        return prices.reduce(function(acc, price) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, price.denom, price));
        }, {});
    }, [
        prices
    ]);
    var ref = (0,react.useState)(false), showPreview = ref[0], setShowPreview = ref[1];
    var ref1 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            title: "",
            description: ""
        }
    }), watch = ref1.watch, register = ref1.register, handleSubmit = ref1.handleSubmit, errors = ref1.formState.errors;
    var proposalTitle = watch("title");
    var proposalDescription = watch("description");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grow space-y-6 pb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "hero-text max-w-prose break-words",
                children: survey.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* MarkdownPreview */.D, {
                markdown: t("info.compensationCycleClosedAwaitingCompletion")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-8",
                children: [
                    survey.attributes.map(function(param, attributeIndex) {
                        var name = param.name;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "primary-text",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid-rows-auto grid items-stretch justify-items-stretch",
                                    // Column for contributor and each rater.
                                    style: {
                                        gridTemplateColumns: "minmax(0,1fr) ".concat(completeRatings.ratings.map(function() {
                                            return "auto";
                                        }).join(" "))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "rounded-tl-md bg-background-primary p-4",
                                            children: t("title.contributor")
                                        }),
                                        completeRatings.ratings.map(function(param, ratingIndex) {
                                            var rater = param.rater;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDisplay, {
                                                address: rater.address,
                                                className: (0,clsx_m/* default */.Z)("justify-self-end border-l border-border-secondary bg-background-primary p-4", ratingIndex === completeRatings.ratings.length - 1 && "rounded-tr-md"),
                                                walletHexPublicKey: rater.publicKey
                                            }, rater.publicKey);
                                        }),
                                        completeRatings.contributions.map(function(contribution, contributionIndex) {
                                            // Every other row.
                                            var backgroundClassName = contributionIndex % 2 !== 0 && "bg-background-tertiary";
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDisplay, {
                                                        address: contribution.contributor.address,
                                                        className: (0,clsx_m/* default */.Z)("p-4", backgroundClassName, contributionIndex === completeRatings.contributions.length - 1 && "rounded-bl-md"),
                                                        walletHexPublicKey: contribution.contributor.publicKey
                                                    }),
                                                    completeRatings.ratings.map(function(param, ratingIndex) {
                                                        var rater = param.rater, contributions = param.contributions;
                                                        var ref;
                                                        var rating = (ref = contributions.find(function(param) {
                                                            var id = param.id;
                                                            return id === contribution.id;
                                                        })) === null || ref === void 0 ? void 0 : ref.attributes[attributeIndex];
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (0,clsx_m/* default */.Z)("flex flex-col items-end justify-center border-l border-border-secondary p-4", backgroundClassName, ratingIndex === completeRatings.ratings.length - 1 && contributionIndex === completeRatings.contributions.length - 1 && "rounded-br-md"),
                                                            children: typeof rating === "number" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "font-mono",
                                                                children: rating
                                                            }) : null
                                                        }, rater.publicKey);
                                                    })
                                                ]
                                            }, contribution.id);
                                        })
                                    ]
                                })
                            ]
                        }, attributeIndex);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "header-text",
                        children: t("title.proposal")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "flex flex-col gap-4",
                        onSubmit: handleSubmit(onComplete),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "rounded-lg bg-background-tertiary",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center justify-between gap-6 border-b border-border-secondary py-4 px-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "primary-text text-text-body",
                                                children: t("form.proposalsName")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex grow flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextInput */.oil, {
                                                        error: errors.title,
                                                        fieldName: "title",
                                                        placeholder: t("form.proposalsNamePlaceholder"),
                                                        register: register,
                                                        validation: [
                                                            utils/* validateRequired */.QK
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                                        error: errors.title
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-4 p-6 pt-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "primary-text text-text-body",
                                                children: [
                                                    t("form.description"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-text-tertiary",
                                                        children: [
                                                            " – ",
                                                            t("info.supportsMarkdownFormat")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextAreaInput */.Fz4, {
                                                        error: errors.description,
                                                        fieldName: "description",
                                                        placeholder: t("form.proposalsDescriptionPlaceholder"),
                                                        register: register,
                                                        rows: 5,
                                                        validation: [
                                                            utils/* validateRequired */.QK
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                                        error: errors.description
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid-rows-auto -mb-2 grid items-stretch justify-items-stretch overflow-x-auto pb-4",
                                // Column for contributor and each rater.
                                style: {
                                    gridTemplateColumns: "1fr ".concat(survey.attributes.map(function() {
                                        return "auto";
                                    }).join(" "), " auto")
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "rounded-tl-md bg-background-primary p-4",
                                        children: t("title.contributor")
                                    }),
                                    survey.attributes.map(function(param, attributeIndex) {
                                        var name = param.name;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "border-l border-border-secondary bg-background-primary p-4 text-right",
                                            children: name
                                        }, attributeIndex);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "rounded-tr-md border-l border-border-secondary bg-background-primary p-4 text-right",
                                        children: t("title.compensation")
                                    }),
                                    completeRatings.contributions.map(function(param, contributionIndex) {
                                        var id = param.id, contributor = param.contributor, compensation = param.compensation;
                                        var ref;
                                        // Every other row.
                                        var backgroundClassName = contributionIndex % 2 !== 0 && "bg-background-tertiary";
                                        var _denom, ref1;
                                        var nativeTokens = compensation.compensationPerAttribute.flatMap(function(param) {
                                            var nativeTokens = param.nativeTokens;
                                            return nativeTokens;
                                        }).reduce(function(acc, param) {
                                            var denom = param.denom, amount = param.amount;
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, denom, ((_denom = acc[denom]) !== null && _denom !== void 0 ? _denom : 0) + (0,utils/* convertMicroDenomToDenomWithDecimals */.rk)(amount, (ref1 = (0,utils/* nativeTokenDecimals */.OZ)(denom)) !== null && ref1 !== void 0 ? ref1 : 0)));
                                        }, {});
                                        var _address, ref2;
                                        var cw20Tokens = compensation.compensationPerAttribute.flatMap(function(param) {
                                            var cw20Tokens = param.cw20Tokens;
                                            return cw20Tokens;
                                        }).reduce(function(acc, param) {
                                            var address = param.address, amount = param.amount;
                                            var ref;
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, address, ((_address = acc[address]) !== null && _address !== void 0 ? _address : 0) + (0,utils/* convertMicroDenomToDenomWithDecimals */.rk)(amount, (ref2 = (ref = cw20TokenInfosMap[address]) === null || ref === void 0 ? void 0 : ref.decimals) !== null && ref2 !== void 0 ? ref2 : 0)));
                                        }, {});
                                        var ref3, ref4;
                                        var totalUsdc = (0,_to_consumable_array/* default */.Z)(Object.entries(nativeTokens).map(function(param) {
                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), denom = _param[0], amount = _param[1];
                                            var ref;
                                            return ((ref3 = (ref = pricesMap[denom]) === null || ref === void 0 ? void 0 : ref.amount) !== null && ref3 !== void 0 ? ref3 : 0) * amount;
                                        })).concat((0,_to_consumable_array/* default */.Z)(Object.entries(cw20Tokens).map(function(param) {
                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), address = _param[0], amount = _param[1];
                                            var ref;
                                            return ((ref4 = (ref = pricesMap[address]) === null || ref === void 0 ? void 0 : ref.amount) !== null && ref4 !== void 0 ? ref4 : 0) * amount;
                                        }))).reduce(function(acc, amount) {
                                            return acc + amount;
                                        }, 0);
                                        var ref5, ref6, ref7;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDisplay, {
                                                    address: contributor.address,
                                                    className: (0,clsx_m/* default */.Z)("p-4", backgroundClassName, contributionIndex === completeRatings.contributions.length - 1 && "rounded-bl-md"),
                                                    walletHexPublicKey: contributor.publicKey
                                                }),
                                                survey.attributes.map(function(_, attributeIndex) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (0,clsx_m/* default */.Z)("flex flex-col items-end justify-center border-l border-border-secondary p-4 font-mono", backgroundClassName),
                                                        children: compensation.compensationPerAttribute[attributeIndex].averageRating
                                                    }, attributeIndex);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx_m/* default */.Z)("flex flex-col items-end justify-center gap-1 border-l border-border-secondary p-4", backgroundClassName, contributionIndex === completeRatings.contributions.length - 1 && "rounded-br-md"),
                                                    children: [
                                                        Object.entries(nativeTokens).map(function(param, index) {
                                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), denom = _param[0], amount = _param[1];
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TokenAmountDisplay */.eWS, {
                                                                amount: amount,
                                                                className: "text-right",
                                                                decimals: (ref5 = (0,utils/* nativeTokenDecimals */.OZ)(denom)) !== null && ref5 !== void 0 ? ref5 : 0,
                                                                iconUrl: (0,utils/* nativeTokenLogoURI */.ni)(denom),
                                                                symbol: (0,utils/* nativeTokenLabel */.S0)(denom)
                                                            }, index);
                                                        }),
                                                        Object.entries(cw20Tokens).map(function(param, index) {
                                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), address = _param[0], amount = _param[1];
                                                            var ref, ref1, ref2;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(stateless/* TokenAmountDisplay */.eWS, {
                                                                amount: amount,
                                                                className: "text-right",
                                                                decimals: (ref6 = (ref = cw20TokenInfosMap[address]) === null || ref === void 0 ? void 0 : ref.decimals) !== null && ref6 !== void 0 ? ref6 : 0,
                                                                iconUrl: ((ref1 = cw20TokenInfosMap[address]) === null || ref1 === void 0 ? void 0 : ref1.logoUrl) || (0,utils/* getFallbackImage */.Ey)(address),
                                                                symbol: (ref7 = (ref2 = cw20TokenInfosMap[address]) === null || ref2 === void 0 ? void 0 : ref2.symbol) !== null && ref7 !== void 0 ? ref7 : address
                                                            }, index);
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-2",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TokenAmountDisplay */.eWS, {
                                                                amount: totalUsdc,
                                                                className: "caption-text text-right",
                                                                dateFetched: (ref = prices[0]) === null || ref === void 0 ? void 0 : ref.timestamp,
                                                                hideApprox: true,
                                                                prefix: "= ",
                                                                usdcConversion: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center justify-end gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Button */.zxk, {
                                        disabled: loading,
                                        onClick: function() {
                                            return setShowPreview(function(p) {
                                                return !p;
                                            });
                                        },
                                        size: "lg",
                                        type: "button",
                                        variant: "secondary",
                                        children: showPreview ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                t("button.hidePreview"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {
                                                    className: "!h-5 !w-5"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                t("button.preview"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {
                                                    className: "!h-5 !w-5"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* Button */.zxk, {
                                        loading: loading,
                                        size: "lg",
                                        type: "submit",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: t("button.publishProposal")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GavelRounded/* default */.Z, {
                                                className: "!h-4 !w-4"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4 rounded-md border border-border-secondary p-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* ProposalContentDisplay */.cNb, {
                                    actionDisplay: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* CosmosMessageDisplay */.IME, {
                                        value: (0,utils/* decodedMessagesString */.er)(completeRatings.cosmosMsgs)
                                    }),
                                    createdAt: new Date(),
                                    creator: {
                                        address: walletAddress,
                                        name: profile.loading ? profile : {
                                            loading: false,
                                            data: profile.data.name
                                        }
                                    },
                                    description: proposalDescription,
                                    title: proposalTitle
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateful/ProposalCreationForm.tsx






















var ProposalCreationForm_ProposalCreationForm = function(param) {
    var data = param.data;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var ref = (0,stateless/* useDaoInfoContext */.XMV)(), coreAddress = ref.coreAddress, chainId = ref.chainId;
    var ref1 = (0,dist.useWallet)(chainId), tmp = ref1.address, walletAddress = tmp === void 0 ? "" : tmp, walletPublicKey = ref1.publicKey;
    var postRequest = usePostRequest();
    var statusLoadable = (0,stateless/* useCachedLoadable */.VwH)((walletPublicKey === null || walletPublicKey === void 0 ? void 0 : walletPublicKey.hex) ? statusSelector({
        daoAddress: coreAddress,
        walletPublicKey: walletPublicKey.hex
    }) : undefined);
    var setRefreshStatus = (0,es/* useSetRecoilState */.Zl)(refreshStatusAtom({
        daoAddress: coreAddress
    }));
    var publishProposal = (0,hooks/* useDaoProposalSinglePublishProposal */.jm)();
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var onComplete = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formData) {
            var proposalData, proposalId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 3;
                            break;
                        }
                        react_hot_toast_esm/* default.error */.ZP.error(t("error.loadingData"));
                        return _ctx.abrupt("return");
                    case 3:
                        if (publishProposal) {
                            _ctx.next = 6;
                            break;
                        }
                        react_hot_toast_esm/* default.error */.ZP.error(t("error.noSingleChoiceProposalModule"));
                        return _ctx.abrupt("return");
                    case 6:
                        setLoading(true);
                        _ctx.prev = 7;
                        proposalData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                            msgs: data.cosmosMsgs
                        });
                        _ctx.next = 11;
                        return publishProposal(proposalData);
                    case 11:
                        proposalId = _ctx.sent.proposalId;
                        react_hot_toast_esm/* default.success */.ZP.success(t("success.proposalCreatedCompleteCompensationCycle"));
                        _ctx.next = 15;
                        return postRequest("/".concat(coreAddress, "/complete"), {
                            proposalId: proposalId
                        });
                    case 15:
                        react_hot_toast_esm/* default.success */.ZP.success(t("success.compensationCycleCompleted"));
                        // Reload status on success.
                        setRefreshStatus(function(id) {
                            return id + 1;
                        });
                        // Navigate to proposal.
                        router.push("/dao/".concat(coreAddress, "/proposals/").concat(proposalId));
                        _ctx.next = 25;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](7);
                        console.error(_ctx.t0);
                        react_hot_toast_esm/* default.error */.ZP.error((0,_instanceof/* default */.Z)(_ctx.t0, Error) ? _ctx.t0.message : JSON.stringify(_ctx.t0));
                        setLoading(false);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    20
                ]
            ]);
        }));
        return function(formData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        data,
        coreAddress,
        postRequest,
        publishProposal,
        router,
        setRefreshStatus,
        t, 
    ]);
    var loadingCw20TokenInfos = (0,stateless/* useCachedLoadable */.VwH)(statusLoadable.state === "hasValue" && statusLoadable.contents ? (0,es/* waitForAll */.k9)(statusLoadable.contents.survey.attributes.flatMap(function(param) {
        var cw20Tokens = param.cw20Tokens;
        return cw20Tokens.map(function(param) {
            var address = param.address;
            return recoil/* Cw20BaseSelectors.tokenInfoWithAddressAndLogoSelector */.e6.tokenInfoWithAddressAndLogoSelector({
                contractAddress: address,
                chainId: chainId,
                params: []
            });
        });
    })) : undefined);
    var prices = (0,stateless/* useCachedLoadable */.VwH)(statusLoadable.state === "hasValue" && statusLoadable.contents && loadingCw20TokenInfos.state === "hasValue" ? (0,es/* waitForAll */.k9)(statusLoadable.contents.survey.attributes.flatMap(function(param) {
        var nativeTokens = param.nativeTokens, cw20Tokens = param.cw20Tokens;
        return (0,_to_consumable_array/* default */.Z)(nativeTokens.map(function(param) {
            var denom = param.denom;
            var decimals = (0,utils/* nativeTokenDecimals */.OZ)(denom);
            if (decimals === undefined) {
                throw new Error("Unknown denom: ".concat(denom));
            }
            return (0,recoil/* usdcPerMacroTokenSelector */.Ot)({
                denom: denom,
                decimals: decimals
            });
        })).concat((0,_to_consumable_array/* default */.Z)(cw20Tokens.map(function(param, cw20TokenIndex) {
            var address = param.address;
            return (0,recoil/* usdcPerMacroTokenSelector */.Ot)({
                denom: address,
                decimals: loadingCw20TokenInfos.contents[cw20TokenIndex].decimals
            });
        })));
    })) : undefined);
    var profile = (0,hooks/* useProfile */.Un)({
        address: walletAddress,
        walletHexPublicKey: walletPublicKey === null || walletPublicKey === void 0 ? void 0 : walletPublicKey.hex,
        chainId: chainId
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SuspenseLoader */.yI, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Loader */.aNw, {}),
        forceFallback: statusLoadable.state === "loading" || loadingCw20TokenInfos.state === "loading" || prices.state === "loading",
        children: statusLoadable.state === "hasValue" && !!statusLoadable.contents && loadingCw20TokenInfos.state === "hasValue" && prices.state === "hasValue" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProposalCreationForm, {
            ProfileDisplay: components/* ProfileDisplay */.Y$,
            completeRatings: data,
            cw20TokenInfos: loadingCw20TokenInfos.contents,
            loading: loading || statusLoadable.updating,
            onComplete: onComplete,
            prices: prices.contents.filter(Boolean),
            profile: profile,
            status: statusLoadable.contents,
            walletAddress: walletAddress
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@cosmjs/encoding/build/index.js
var build = __webpack_require__(20302);
;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateless/RatingForm.tsx














var RatingForm = function(param) {
    var _status = param.status, survey = _status.survey, rated = _status.rated, data = param.data, onSubmit = param.onSubmit, loadingSubmit = param.loadingSubmit, ProfileDisplay = param.ProfileDisplay, AddressInput = param.AddressInput, cw20TokenInfos = param.cw20TokenInfos, prices = param.prices, onNominate = param.onNominate, loadingNominate = param.loadingNominate;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            ratings: []
        }
    }), watch = ref.watch, setValue = ref.setValue, handleSubmit = ref.handleSubmit, reset = ref.reset;
    // When contributions load, set the default form values.
    var ratings = watch("ratings");
    (0,react.useEffect)(function() {
        if (data && ratings.length !== data.contributions.length) {
            var ref;
            reset({
                ratings: data.contributions.map(function(param) {
                    var id = param.id;
                    var ref1;
                    return {
                        contributionId: id,
                        attributes: // Try to find existing rating.
                        (0,_to_consumable_array/* default */.Z)((ref = (ref1 = data.existingRatings.find(function(param) {
                            var contributionId = param.contributionId;
                            return contributionId === id;
                        })) === null || ref1 === void 0 ? void 0 : ref1.attributes) !== null && ref !== void 0 ? ref : // Default to abstain.
                        survey.attributes.map(function() {
                            return null;
                        }))
                    };
                })
            });
        }
    }, [
        data,
        ratings,
        reset,
        survey.attributes
    ]);
    // Compute compensation for each contribution.
    var compensation = data ? computeCompensation(data.contributions.map(function(param) {
        var id = param.id;
        return id;
    }), ratings, survey.attributes) : [];
    // Convert cw20TokenInfos into map of token addresses to token info.
    var cw20TokenInfosMap = (0,react.useMemo)(function() {
        return cw20TokenInfos.reduce(function(acc, tokenInfo) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, tokenInfo.address, tokenInfo));
        }, {});
    }, [
        cw20TokenInfos
    ]);
    // Convert prices into map of token to price.
    var pricesMap = (0,react.useMemo)(function() {
        return prices.reduce(function(acc, price) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, price.denom, price));
        }, {});
    }, [
        prices
    ]);
    var ref1 = (0,index_esm/* useForm */.cI)(), nominationWatch = ref1.watch, nominationRegister = ref1.register, nominationHandleSubmit = ref1.handleSubmit, _formState = ref1.formState, nominationErrors = _formState.errors, nominationSetValue = ref1.setValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex grow flex-col gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-prose space-y-1 break-words",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "hero-text",
                        children: survey.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "caption-text italic",
                        children: t("info.ratingClosesAt", {
                            date: (0,utils/* formatDateTimeTz */.F)(new Date(survey.ratingsCloseAt))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* MarkdownPreview */.D, {
                markdown: survey.ratingInstructions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "flex flex-col gap-4 pb-10",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid-rows-auto -mb-2 grid items-stretch justify-items-stretch overflow-x-auto pb-4",
                        // Column for contributor, each attribute, and projected
                        // compenstaion.
                        style: {
                            gridTemplateColumns: "1fr ".concat(survey.attributes.map(function() {
                                return "auto";
                            }).join(" "), " auto")
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "rounded-tl-md bg-background-primary p-6",
                                children: t("title.contributor")
                            }),
                            survey.attributes.map(function(param, attributeIndex) {
                                var name = param.name;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "border-l border-border-secondary bg-background-primary p-6",
                                    children: name
                                }, attributeIndex);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "rounded-tr-md border-l border-border-secondary bg-background-primary p-6 text-right",
                                children: t("title.projectedCompensation")
                            }),
                            data.contributions.map(function(contribution, contributionIndex) {
                                var ref;
                                // Every other row.
                                var backgroundClassName = contributionIndex % 2 !== 0 && "bg-background-tertiary";
                                var compensationForContribution = compensation[contributionIndex].compensationPerAttribute;
                                var _denom, ref1;
                                var nativeTokens = compensationForContribution.flatMap(function(param) {
                                    var nativeTokens = param.nativeTokens;
                                    return nativeTokens;
                                }).reduce(function(acc, param) {
                                    var denom = param.denom, amount = param.amount;
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, denom, ((_denom = acc[denom]) !== null && _denom !== void 0 ? _denom : 0) + (0,utils/* convertMicroDenomToDenomWithDecimals */.rk)(amount, (ref1 = (0,utils/* nativeTokenDecimals */.OZ)(denom)) !== null && ref1 !== void 0 ? ref1 : 0)));
                                }, {});
                                var _address, ref2;
                                var cw20Tokens = compensationForContribution.flatMap(function(param) {
                                    var cw20Tokens = param.cw20Tokens;
                                    return cw20Tokens;
                                }).reduce(function(acc, param) {
                                    var address = param.address, amount = param.amount;
                                    var ref;
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, address, ((_address = acc[address]) !== null && _address !== void 0 ? _address : 0) + (0,utils/* convertMicroDenomToDenomWithDecimals */.rk)(amount, (ref2 = (ref = cw20TokenInfosMap[address]) === null || ref === void 0 ? void 0 : ref.decimals) !== null && ref2 !== void 0 ? ref2 : 0)));
                                }, {});
                                var ref3, ref4;
                                var totalUsdc = (0,_to_consumable_array/* default */.Z)(Object.entries(nativeTokens).map(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), denom = _param[0], amount = _param[1];
                                    var ref;
                                    return ((ref3 = (ref = pricesMap[denom]) === null || ref === void 0 ? void 0 : ref.amount) !== null && ref3 !== void 0 ? ref3 : 0) * amount;
                                })).concat((0,_to_consumable_array/* default */.Z)(Object.entries(cw20Tokens).map(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), address = _param[0], amount = _param[1];
                                    var ref;
                                    return ((ref4 = (ref = pricesMap[address]) === null || ref === void 0 ? void 0 : ref.amount) !== null && ref4 !== void 0 ? ref4 : 0) * amount;
                                }))).reduce(function(acc, amount) {
                                    return acc + amount;
                                }, 0);
                                var attributeRatingsFieldName = "ratings.".concat(contributionIndex, ".attributes");
                                var attributeRatings = watch(attributeRatingsFieldName) || [];
                                var allRatingsAbstain = attributeRatings.every(function(rating) {
                                    return rating === null;
                                });
                                var toggleAbstain = function() {
                                    return allRatingsAbstain ? setValue(attributeRatingsFieldName, (0,_to_consumable_array/* default */.Z)(Array(survey.attributes.length)).map(function() {
                                        return 0;
                                    })) : setValue(attributeRatingsFieldName, (0,_to_consumable_array/* default */.Z)(Array(survey.attributes.length)).map(function() {
                                        return null;
                                    }));
                                };
                                var ref5, ref6, ref7;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)("min-w-[14rem] space-y-2 border-border-secondary p-6", backgroundClassName, contributionIndex === data.contributions.length - 1 && "rounded-bl-md"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDisplay, {
                                                    address: contribution.contributor.address,
                                                    walletHexPublicKey: contribution.contributor.publicKey
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* MarkdownPreview */.D, {
                                                    className: "styled-scrollbar max-h-40 overflow-y-auto py-2 pr-2",
                                                    markdown: contribution.content
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "!mt-4 flex flex-row items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Checkbox */.XZJ, {
                                                            checked: allRatingsAbstain,
                                                            onClick: toggleAbstain,
                                                            size: "sm"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "body-text cursor-pointer text-xs",
                                                            onClick: toggleAbstain,
                                                            children: t("info.dontKnowNotSure")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        survey.attributes.map(function(_, attributeIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)("flex flex-col justify-center border-l border-border-secondary p-6", backgroundClassName),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* RangeInput */.LO7, {
                                                    className: "!h-20 w-40",
                                                    fieldName: "ratings.".concat(contributionIndex, ".attributes.").concat(attributeIndex),
                                                    max: 100,
                                                    min: 0,
                                                    onStartChange: // If starting to change, unset abstaining for
                                                    // all.
                                                    allRatingsAbstain ? toggleAbstain : undefined,
                                                    setValue: setValue,
                                                    watch: watch
                                                })
                                            }, attributeIndex);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)("flex flex-col items-end justify-center gap-1 border-l border-border-secondary p-6", backgroundClassName, contributionIndex === data.contributions.length - 1 && "rounded-br-md"),
                                            children: !allRatingsAbstain && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    Object.entries(nativeTokens).map(function(param, index) {
                                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), denom = _param[0], amount = _param[1];
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TokenAmountDisplay */.eWS, {
                                                            amount: amount,
                                                            className: "text-right",
                                                            decimals: (ref5 = (0,utils/* nativeTokenDecimals */.OZ)(denom)) !== null && ref5 !== void 0 ? ref5 : 0,
                                                            iconUrl: (0,utils/* nativeTokenLogoURI */.ni)(denom),
                                                            symbol: (0,utils/* nativeTokenLabel */.S0)(denom)
                                                        }, index);
                                                    }),
                                                    Object.entries(cw20Tokens).map(function(param, index) {
                                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), address = _param[0], amount = _param[1];
                                                        var ref, ref1, ref2;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(stateless/* TokenAmountDisplay */.eWS, {
                                                            amount: amount,
                                                            className: "text-right",
                                                            decimals: (ref6 = (ref = cw20TokenInfosMap[address]) === null || ref === void 0 ? void 0 : ref.decimals) !== null && ref6 !== void 0 ? ref6 : 0,
                                                            iconUrl: ((ref1 = cw20TokenInfosMap[address]) === null || ref1 === void 0 ? void 0 : ref1.logoUrl) || (0,utils/* getFallbackImage */.Ey)(address),
                                                            symbol: (ref7 = (ref2 = cw20TokenInfosMap[address]) === null || ref2 === void 0 ? void 0 : ref2.symbol) !== null && ref7 !== void 0 ? ref7 : address
                                                        }, index);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TokenAmountDisplay */.eWS, {
                                                            amount: totalUsdc,
                                                            className: "caption-text text-right",
                                                            dateFetched: (ref = prices[0]) === null || ref === void 0 ? void 0 : ref.timestamp,
                                                            hideApprox: true,
                                                            prefix: "= ",
                                                            usdcConversion: true
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, contribution.id);
                            })
                        ]
                    }),
                    rated && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "caption-text self-end text-right text-text-interactive-valid",
                        children: t("form.ratingsSubmitted")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* Button */.zxk, {
                        className: "self-end",
                        disabled: loadingNominate,
                        loading: loadingSubmit,
                        type: "submit",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: rated ? t("button.update") : t("button.submit")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Publish, {
                                className: "!h-4 !w-4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col rounded-lg bg-background-tertiary p-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "title-text mb-2",
                        children: t("title.nominateContributor")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* MarkdownPreview */.D, {
                        markdown: t("info.nominateContributorDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "mt-6 flex flex-col gap-4",
                        onSubmit: nominationHandleSubmit(onNominate),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputLabel */.AZs, {
                                        name: t("form.contributorAddress")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInput, {
                                        containerClassName: "grow",
                                        error: nominationErrors === null || nominationErrors === void 0 ? void 0 : nominationErrors.contributor,
                                        fieldName: "contributor",
                                        register: nominationRegister,
                                        setValue: nominationSetValue,
                                        validation: [
                                            utils/* validateRequired */.QK,
                                            utils/* validateAddress */.YN
                                        ],
                                        watch: nominationWatch
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                        error: nominationErrors === null || nominationErrors === void 0 ? void 0 : nominationErrors.contributor
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputLabel */.AZs, {
                                        name: t("form.contribution")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* TextAreaInput */.Fz4, {
                                        error: nominationErrors === null || nominationErrors === void 0 ? void 0 : nominationErrors.contribution,
                                        fieldName: "contribution",
                                        register: nominationRegister,
                                        rows: 10,
                                        validation: [
                                            utils/* validateRequired */.QK
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* InputErrorMessage */.fm2, {
                                        error: nominationErrors === null || nominationErrors === void 0 ? void 0 : nominationErrors.contribution
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(stateless/* Button */.zxk, {
                                className: "self-end",
                                disabled: loadingSubmit,
                                loading: loadingNominate,
                                type: "submit",
                                children: [
                                    t("button.nominate"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Publish, {
                                        className: "!h-4 !w-4"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateful/RatingForm.tsx





















var RatingForm_RatingForm = function(param) {
    var data = param.data, reloadData = param.reloadData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,stateless/* useDaoInfoContext */.XMV)(), coreAddress = ref.coreAddress, chainId = ref.chainId;
    var ref1 = (0,dist.useWallet)(chainId), walletPublicKey = ref1.publicKey;
    var client = (0,es/* useRecoilValue */.sJ)((0,recoil/* cosmWasmClientForChainSelector */.KN)(chainId));
    var postRequest = usePostRequest();
    var statusLoadable = (0,stateless/* useCachedLoadable */.VwH)((walletPublicKey === null || walletPublicKey === void 0 ? void 0 : walletPublicKey.hex) ? statusSelector({
        daoAddress: coreAddress,
        walletPublicKey: walletPublicKey.hex
    }) : undefined);
    var setRefreshStatus = (0,es/* useSetRecoilState */.Zl)(refreshStatusAtom({
        daoAddress: coreAddress
    }));
    var ref2 = (0,react.useState)(false), loadingSubmit = ref2[0], setLoadingSubmit = ref2[1];
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoadingSubmit(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return postRequest("/".concat(coreAddress, "/rate"), (0,_object_spread/* default */.Z)({}, data));
                    case 4:
                        react_hot_toast_esm/* default.success */.ZP.success(t("success.ratingsSubmitted"));
                        // Reload status on success.
                        setRefreshStatus(function(id) {
                            return id + 1;
                        });
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                        react_hot_toast_esm/* default.error */.ZP.error((0,_instanceof/* default */.Z)(_ctx.t0, Error) ? _ctx.t0.message : JSON.stringify(_ctx.t0));
                    case 12:
                        _ctx.prev = 12;
                        setLoadingSubmit(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8,
                    12,
                    15
                ]
            ]);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        coreAddress,
        postRequest,
        setRefreshStatus,
        t
    ]);
    var loadingCw20TokenInfos = (0,stateless/* useCachedLoadable */.VwH)(statusLoadable.state === "hasValue" && statusLoadable.contents ? (0,es/* waitForAll */.k9)(statusLoadable.contents.survey.attributes.flatMap(function(param) {
        var cw20Tokens = param.cw20Tokens;
        return cw20Tokens.map(function(param) {
            var address = param.address;
            return recoil/* Cw20BaseSelectors.tokenInfoWithAddressAndLogoSelector */.e6.tokenInfoWithAddressAndLogoSelector({
                contractAddress: address,
                chainId: chainId,
                params: []
            });
        });
    })) : undefined);
    var prices = (0,stateless/* useCachedLoadable */.VwH)(statusLoadable.state === "hasValue" && statusLoadable.contents && loadingCw20TokenInfos.state === "hasValue" ? (0,es/* waitForAll */.k9)(statusLoadable.contents.survey.attributes.flatMap(function(param) {
        var nativeTokens = param.nativeTokens, cw20Tokens = param.cw20Tokens;
        return (0,_to_consumable_array/* default */.Z)(nativeTokens.map(function(param) {
            var denom = param.denom;
            var decimals = (0,utils/* nativeTokenDecimals */.OZ)(denom);
            if (decimals === undefined) {
                throw new Error("Unknown denom: ".concat(denom));
            }
            return (0,recoil/* usdcPerMacroTokenSelector */.Ot)({
                denom: denom,
                decimals: decimals
            });
        })).concat((0,_to_consumable_array/* default */.Z)(cw20Tokens.map(function(param, cw20TokenIndex) {
            var address = param.address;
            return (0,recoil/* usdcPerMacroTokenSelector */.Ot)({
                denom: address,
                decimals: loadingCw20TokenInfos.contents[cw20TokenIndex].decimals
            });
        })));
    })) : undefined);
    var ref3 = (0,react.useState)(false), loadingNominate = ref3[0], setLoadingNominate = ref3[1];
    var onNominate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formData) {
            var ref, account, contributorPublicKey;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoadingNominate(true);
                        _ctx.prev = 1;
                        ;
                        _ctx.next = 5;
                        return client.getAccount(formData.contributor);
                    case 5:
                        account = _ctx.sent;
                        if (account === null || account === void 0 ? void 0 : (ref = account.pubkey) === null || ref === void 0 ? void 0 : ref.value) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(t("error.addressNotFoundOnChain"));
                    case 8:
                        contributorPublicKey = (0,build.toHex)((0,build.fromBase64)(account.pubkey.value));
                        _ctx.next = 11;
                        return postRequest("/".concat(coreAddress, "/nominate"), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                            contributor: contributorPublicKey
                        }));
                    case 11:
                        react_hot_toast_esm/* default.success */.ZP.success(t("success.nominationSubmitted"));
                        if (!data) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 15;
                        return reloadData();
                    case 15:
                        _ctx.next = 21;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                        react_hot_toast_esm/* default.error */.ZP.error((0,_instanceof/* default */.Z)(_ctx.t0, Error) ? _ctx.t0.message : JSON.stringify(_ctx.t0));
                    case 21:
                        _ctx.prev = 21;
                        setLoadingNominate(false);
                        return _ctx.finish(21);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17,
                    21,
                    24
                ]
            ]);
        }));
        return function(formData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        client,
        coreAddress,
        data,
        postRequest,
        reloadData,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SuspenseLoader */.yI, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Loader */.aNw, {}),
        forceFallback: statusLoadable.state === "loading" || loadingCw20TokenInfos.state === "loading" || prices.state === "loading",
        children: statusLoadable.state === "hasValue" && !!statusLoadable.contents && loadingCw20TokenInfos.state === "hasValue" && prices.state === "hasValue" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingForm, {
            AddressInput: components/* AddressInput */.Jg,
            ProfileDisplay: components/* ProfileDisplay */.Y$,
            cw20TokenInfos: loadingCw20TokenInfos.contents,
            data: data,
            loadingNominate: loadingNominate,
            loadingSubmit: loadingSubmit || statusLoadable.updating,
            onNominate: onNominate,
            onSubmit: onSubmit,
            prices: prices.contents.filter(Boolean),
            status: statusLoadable.contents
        })
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateful/OpenSurveySection.tsx






















var OpenSurveySection_OpenSurveySection = function(param) {
    var status = param.status;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,stateless/* useDaoInfoContext */.XMV)(), coreAddress = ref.coreAddress, chainId = ref.chainId, bech32Prefix = ref.bech32Prefix;
    var connected = (0,dist.useWallet)().connected;
    // Voting power at time of survey creation, which determines what access level
    // this wallet has.
    var ref1 = (0,hooks/* useMembership */.e7)({
        coreAddress: coreAddress,
        chainId: chainId,
        blockHeight: status.survey.createdAtBlockHeight
    }), _isMember = ref1.isMember, isMember = _isMember === void 0 ? false : _isMember;
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(false), showContributionForm = ref3[0], setShowContributionForm = ref3[1];
    var ref4 = (0,react.useState)(), ratingFormData = ref4[0], setRatingFormData = ref4[1];
    var ref5 = (0,react.useState)(), proposalCreationFormData = ref5[0], setProposalCreationFormData = ref5[1];
    var postRequest = usePostRequest();
    var loadRatingFormData = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, contributions;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setLoading(true);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return postRequest("/".concat(coreAddress, "/contributions"));
                case 4:
                    response = _ctx.sent;
                    _ctx.next = 7;
                    return Promise.all(response.contributions.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
                            var publicKey, contribution, address;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        publicKey = _param.contributor, contribution = (0,_object_without_properties/* default */.Z)(_param, [
                                            "contributor"
                                        ]);
                                        _ctx.next = 3;
                                        return (0,utils/* secp256k1PublicKeyToBech32Address */.QC)(publicKey, bech32Prefix);
                                    case 3:
                                        address = _ctx.sent;
                                        return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contribution), {
                                            contributor: {
                                                publicKey: publicKey,
                                                address: address
                                            }
                                        }));
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(_param) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                case 7:
                    contributions = _ctx.sent;
                    setRatingFormData({
                        contributions: contributions,
                        existingRatings: response.ratings
                    });
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    console.error(_ctx.t0);
                    react_hot_toast_esm/* default.error */.ZP.error((0,_instanceof/* default */.Z)(_ctx.t0, Error) ? _ctx.t0.message : JSON.stringify(_ctx.t0));
                case 15:
                    _ctx.prev = 15;
                    setLoading(false);
                    return _ctx.finish(15);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11,
                15,
                18
            ]
        ]);
    })), [
        bech32Prefix,
        coreAddress,
        postRequest
    ]);
    var loadProposalCreationFormData = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, compensationPerContribution, contributions, ratings, cosmosMsgs, completeRatings;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setLoading(true);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return postRequest("/".concat(coreAddress, "/ratings"));
                case 4:
                    response = _ctx.sent;
                    compensationPerContribution = computeCompensation(response.contributions.map(function(param) {
                        var id = param.id;
                        return id;
                    }), response.ratings.flatMap(function(rating) {
                        return rating.contributions.map(function(param) {
                            var id = param.id, attributes = param.attributes;
                            return {
                                contributionId: id,
                                attributes: attributes
                            };
                        });
                    }), status.survey.attributes);
                    _ctx.next = 8;
                    return Promise.all(response.contributions.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param, contributionIndex) {
                            var publicKey, contribution, address, compensation;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        publicKey = _param.contributor, contribution = (0,_object_without_properties/* default */.Z)(_param, [
                                            "contributor"
                                        ]);
                                        _ctx.next = 3;
                                        return (0,utils/* secp256k1PublicKeyToBech32Address */.QC)(publicKey, bech32Prefix);
                                    case 3:
                                        address = _ctx.sent;
                                        compensation = compensationPerContribution[contributionIndex];
                                        return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contribution), {
                                            contributor: {
                                                publicKey: publicKey,
                                                address: address
                                            },
                                            compensation: compensation
                                        }));
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(_param, contributionIndex) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                case 8:
                    contributions = _ctx.sent;
                    _ctx.next = 11;
                    return Promise.all(response.ratings.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
                            var publicKey, rating, address;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        publicKey = _param.rater, rating = (0,_object_without_properties/* default */.Z)(_param, [
                                            "rater"
                                        ]);
                                        _ctx.next = 3;
                                        return (0,utils/* secp256k1PublicKeyToBech32Address */.QC)(publicKey, bech32Prefix);
                                    case 3:
                                        address = _ctx.sent;
                                        return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rating), {
                                            rater: {
                                                publicKey: publicKey,
                                                address: address
                                            }
                                        }));
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(_param) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                case 11:
                    ratings = _ctx.sent;
                    cosmosMsgs = contributions.flatMap(function(param) {
                        var contributor = param.contributor, compensation = param.compensation;
                        return compensation.compensationPerAttribute.flatMap(function(param) {
                            var nativeTokens = param.nativeTokens, cw20Tokens = param.cw20Tokens;
                            return (0,_to_consumable_array/* default */.Z)(nativeTokens.map(function(param) {
                                var amount = param.amount, denom = param.denom;
                                return {
                                    bank: (0,utils/* makeBankMessage */.wc)(amount, contributor.address, denom)
                                };
                            })).concat((0,_to_consumable_array/* default */.Z)(cw20Tokens.map(function(param) {
                                var amount = param.amount, address = param.address;
                                return (0,utils/* makeWasmMessage */.xd)({
                                    wasm: {
                                        execute: {
                                            contract_addr: address,
                                            funds: [],
                                            msg: {
                                                transfer: {
                                                    recipient: contributor.address,
                                                    amount: amount
                                                }
                                            }
                                        }
                                    }
                                });
                            })));
                        });
                    });
                    completeRatings = {
                        contributions: contributions,
                        ratings: ratings,
                        cosmosMsgs: cosmosMsgs
                    };
                    setProposalCreationFormData(completeRatings);
                    _ctx.next = 21;
                    break;
                case 17:
                    _ctx.prev = 17;
                    _ctx.t0 = _ctx["catch"](1);
                    console.error(_ctx.t0);
                    react_hot_toast_esm/* default.error */.ZP.error((0,_instanceof/* default */.Z)(_ctx.t0, Error) ? _ctx.t0.message : JSON.stringify(_ctx.t0));
                case 21:
                    _ctx.prev = 21;
                    setLoading(false);
                    return _ctx.finish(21);
                case 24:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                17,
                21,
                24
            ]
        ]);
    })), [
        bech32Prefix,
        coreAddress,
        postRequest,
        status.survey.attributes
    ]);
    var onClick = status.survey.status === SurveyStatus.Inactive || status.survey.status === SurveyStatus.AcceptingContributions ? function() {
        return setShowContributionForm(true);
    } : isMember ? status.survey.status === SurveyStatus.AcceptingRatings ? loadRatingFormData : status.survey.status === SurveyStatus.AwaitingCompletion ? loadProposalCreationFormData : undefined : undefined;
    var tooltip = isMember ? undefined : status.survey.status === SurveyStatus.AcceptingRatings || status.survey.status === SurveyStatus.AwaitingCompletion ? t("info.submissionsBeingRated") : undefined;
    return (status.survey.status === SurveyStatus.Inactive || status.survey.status === SurveyStatus.AcceptingContributions) && showContributionForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContributionForm_ContributionForm, {})
    }) : status.survey.status === SurveyStatus.AcceptingRatings && isMember && ratingFormData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingForm_RatingForm, {
            data: ratingFormData,
            reloadData: loadRatingFormData
        })
    }) : status.survey.status === SurveyStatus.AwaitingCompletion && isMember && proposalCreationFormData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProposalCreationForm_ProposalCreationForm, {
            data: proposalCreationFormData
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSurveySection, {
        connected: connected,
        isMember: isMember,
        loading: loading,
        onClick: onClick,
        status: status,
        tooltip: tooltip
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/stateful/PayrollTab.tsx























var PayrollTab_PayrollTab = function() {
    var ref = (0,stateless/* useDaoInfoContext */.XMV)(), chainId = ref.chainId, coreAddress = ref.coreAddress, bech32Prefix = ref.bech32Prefix;
    var ref1 = (0,dist.useWallet)(chainId), tmp = ref1.address, walletAddress = tmp === void 0 ? "" : tmp, walletPublicKey = ref1.publicKey;
    var ref2 = (0,hooks/* useMembership */.e7)({
        coreAddress: coreAddress,
        chainId: chainId
    }), _isMember = ref2.isMember, isMember = _isMember === void 0 ? false : _isMember;
    var ref3;
    var loadingStatus = (0,utils/* loadableToLoadingData */.AM)((0,stateless/* useCachedLoadable */.VwH)(statusSelector({
        daoAddress: coreAddress,
        walletPublicKey: (ref3 = walletPublicKey === null || walletPublicKey === void 0 ? void 0 : walletPublicKey.hex) !== null && ref3 !== void 0 ? ref3 : "_"
    })), undefined);
    var loadingCompletedSurveys = (0,utils/* loadableToLoadingData */.AM)((0,stateless/* useCachedLoadable */.VwH)(listCompletedSurveysSelector({
        daoAddress: coreAddress
    })), []);
    // Get voting power at time of each completed survey creation to determine if
    // we can download the CSV or not.
    var loadingMembershipDuringCompletedSurveys = (0,utils/* loadableToLoadingData */.AM)((0,stateless/* useCachedLoadable */.VwH)(loadingCompletedSurveys.loading || !walletAddress ? undefined : (0,es/* waitForAll */.k9)(loadingCompletedSurveys.data.map(function(param) {
        var createdAtBlockHeight = param.createdAtBlockHeight;
        return recoil/* DaoCoreV2Selectors.votingPowerAtHeightSelector */.A2.votingPowerAtHeightSelector({
            contractAddress: coreAddress,
            chainId: chainId,
            params: [
                {
                    address: walletAddress,
                    height: createdAtBlockHeight
                }, 
            ]
        });
    }))), []);
    var postRequest = usePostRequest();
    var ref4 = (0,react.useState)(), loadingCompletedSurveyId = ref4[0], setLoadingCompletedSurveyId = ref4[1];
    var downloadCompletedSurvey = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var id, survey, raterTitles, csvTitles, csvData, csvContent;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id;
                        setLoadingCompletedSurveyId(id);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return postRequest("/".concat(coreAddress, "/view/").concat(id));
                    case 5:
                        survey = _ctx.sent.survey;
                        _ctx.next = 8;
                        return Promise.all(survey.ratings.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(rating) {
                                var raterAddress;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return (0,utils/* secp256k1PublicKeyToBech32Address */.QC)(rating.rater, bech32Prefix);
                                        case 2:
                                            raterAddress = _ctx.sent;
                                            return _ctx.abrupt("return", survey.attributes.map(function(param) {
                                                var name = param.name;
                                                return "".concat(raterAddress, ":").concat(name);
                                            }));
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(rating) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    case 8:
                        raterTitles = _ctx.sent.flat();
                        csvTitles = [
                            "Contributor",
                            "Contribution"
                        ].concat((0,_to_consumable_array/* default */.Z)(raterTitles));
                        _ctx.next = 12;
                        return Promise.all(survey.contributions.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contribution) {
                                var contributorAddress, ref, ratings, _obj;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return (0,utils/* secp256k1PublicKeyToBech32Address */.QC)(contribution.contributor, bech32Prefix);
                                        case 2:
                                            contributorAddress = _ctx.sent;
                                            ;
                                            ratings = survey.ratings.flatMap(function(rating) {
                                                var ref1;
                                                return (ref = (ref1 = rating.contributions.find(function(param) {
                                                    var id = param.id;
                                                    return id === contribution.id;
                                                })) === null || ref1 === void 0 ? void 0 : ref1.attributes.map(function(rating) {
                                                    return typeof rating === "number" ? rating : "";
                                                })) !== null && ref !== void 0 ? ref : [];
                                            });
                                            ;
                                            return _ctx.abrupt("return", (0,_object_spread/* default */.Z)((_obj = {}, (0,_define_property/* default */.Z)(_obj, csvTitles[0], contributorAddress), (0,_define_property/* default */.Z)(_obj, csvTitles[1], contribution.content), _obj), Object.fromEntries(raterTitles.map(function(title, index) {
                                                return [
                                                    title,
                                                    ratings[index]
                                                ];
                                            }))));
                                        case 7:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(contribution) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    case 12:
                        csvData = _ctx.sent;
                        csvContent = (0,json2csv_umd.parse)(csvData, {
                            fields: csvTitles
                        });
                        (0,FileSaver_min.saveAs)(new Blob([
                            csvContent
                        ], {
                            type: "text/plain;charset=utf-8"
                        }), "survey-".concat(id, ".csv"));
                        _ctx.next = 21;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error("Failed to fetch retroactive payroll past survey.", _ctx.t0);
                        react_hot_toast_esm/* default.error */.ZP.error((0,_instanceof/* default */.Z)(_ctx.t0, Error) ? _ctx.t0.message : JSON.stringify(_ctx.t0));
                    case 21:
                        _ctx.prev = 21;
                        setLoadingCompletedSurveyId(undefined);
                        return _ctx.finish(21);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    17,
                    21,
                    24
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        bech32Prefix,
        coreAddress,
        postRequest
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PayrollTab, {
        IconButtonLink: components/* IconButtonLink */.I_,
        NewSurveyForm: NewSurveyForm_NewSurveyForm,
        OpenSurveySection: OpenSurveySection_OpenSurveySection,
        downloadCompletedSurvey: downloadCompletedSurvey,
        isMember: isMember,
        loadingCompletedSurveyId: loadingCompletedSurveyId,
        loadingCompletedSurveys: loadingCompletedSurveys,
        loadingMembershipDuringCompletedSurveys: loadingMembershipDuringCompletedSurveys,
        loadingStatus: loadingStatus
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/components/index.tsx


;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/Retroactive/index.ts

var RetroactiveAdapter = {
    id: "retroactive",
    PayrollTab: PayrollTab_PayrollTab
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/adapters/index.tsx


;// CONCATENATED MODULE: ../../packages/stateful/payroll/core.ts

// The item key in a DAO's core contract that stores the payroll system ID.
var DAO_PAYROLL_ITEM_KEY = "payroll";
// Adapters need to be loaded lazily like this, as opposed to just defining a
// global array, due to cyclic dependencies. The adapter defintion files include
// components, which include the react folder index, which includes the provider
// file, which includes the core because it uses the matching helpers below,
// which depend on this adapter list. The fix is that no internal components
// should have a dependency chain that leads back to the matching functions
// below, except the react provider, which we should only be used externally.
// This is a problem to solve later.
var getAdapters = function() {
    return [
        RetroactiveAdapter
    ];
};
var getAdapterById = function(id) {
    return getAdapters().find(function(adapter) {
        return adapter.id === id;
    });
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/react/usePayrollAdapter.ts
// External API



// Get payroll adapter for the DAO based on its configured payroll system. If
// nothing configured or no system found, returns undefined.
var usePayrollAdapter = function() {
    var ref = (0,stateless/* useDaoInfoContext */.XMV)(), chainId = ref.chainId, coreAddress = ref.coreAddress;
    var payrollItem = (0,stateless/* useCachedLoadable */.VwH)(recoil/* DaoCoreV2Selectors.getItemSelector */.A2.getItemSelector({
        chainId: chainId,
        contractAddress: coreAddress,
        params: [
            {
                key: DAO_PAYROLL_ITEM_KEY
            }, 
        ]
    }));
    return payrollItem.state === "hasValue" && payrollItem.contents.item ? getAdapterById(payrollItem.contents.item) : undefined;
};

;// CONCATENATED MODULE: ../../packages/stateful/payroll/react/index.tsx


;// CONCATENATED MODULE: ../../packages/stateful/payroll/index.tsx




// EXTERNAL MODULE: ../../packages/stateful/proposal-module-adapter/index.tsx + 2 modules
var proposal_module_adapter = __webpack_require__(70341);
// EXTERNAL MODULE: ../../packages/stateful/voting-module-adapter/index.tsx + 35 modules
var voting_module_adapter = __webpack_require__(72983);
// EXTERNAL MODULE: ../../packages/types/index.ts + 8 modules
var types = __webpack_require__(62565);
;// CONCATENATED MODULE: ./pages/dao/[address]/index.tsx
// GNU AFFERO GENERAL PUBLIC LICENSE Version 3. Copyright (C) 2022 DAO DAO Contributors.
// See the "LICENSE" file in the root directory of this package for more copyright information.



















var InnerDaoHome = function() {
    var _Math;
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var connected = (0,dist.useWallet)().connected;
    var ref1 = (0,stateful/* useWalletInfo */.vL)(), walletProfile = ref1.walletProfile, updateProfileName = ref1.updateProfileName;
    var updateProfileNft = (0,stateless/* useAppLayoutContext */.bm4)().updateProfileNft;
    var daoInfo = (0,stateless/* useDaoInfoContext */.XMV)();
    var ref2 = (0,voting_module_adapter/* useVotingModuleAdapter */.aA)(), _components = ref2.components, MembersTab = _components.MembersTab, ProfileCardMemberInfo = _components.ProfileCardMemberInfo;
    var isMember = (0,stateful/* useMembership */.e7)(daoInfo).isMember;
    var _parentDao;
    // If no parent, fallback to current address since it's already loaded from
    // the above hook. We won't use this value unless there's a parent. It's
    // redundant but has no effect.
    var ref3 = (0,stateful/* useMembership */.e7)((_parentDao = daoInfo.parentDao) !== null && _parentDao !== void 0 ? _parentDao : daoInfo), isMemberOfParent = ref3.isMember;
    var parentDaosSubDaosLoadable = (0,es/* useRecoilValueLoadable */.$P)(daoInfo.parentDao ? state/* DaoCoreV2Selectors.listAllSubDaosSelector */.A2.listAllSubDaosSelector({
        contractAddress: daoInfo.parentDao.coreAddress
    }) : (0,es/* constSelector */.Kz)(undefined));
    var manageSubDaosAction = (0,actions/* useCoreActionForKey */.Fc)(types/* CoreActionKey.ManageSubDaos */.bu.ManageSubDaos);
    // Prefill URL only valid if action exists.
    var prefillValid = !!manageSubDaosAction;
    var encodedAddSubDaoProposalPrefill = (0,stateful/* useEncodedDaoProposalSinglePrefill */.oe)(manageSubDaosAction ? {
        title: t("title.recognizeSubDao", {
            name: daoInfo.name
        }),
        description: t("info.recognizeSubDaoDescription", {
            name: daoInfo.name
        }),
        actions: [
            {
                action: manageSubDaosAction,
                data: {
                    toAdd: [
                        {
                            addr: daoInfo.coreAddress
                        }, 
                    ],
                    toRemove: []
                }
            }, 
        ]
    } : {
        actions: []
    });
    var addSubDaoProposalPrefillHref = prefillValid && daoInfo.parentDao && encodedAddSubDaoProposalPrefill ? "/dao/".concat(daoInfo.parentDao.coreAddress, "/proposals/create?prefill=").concat(encodedAddSubDaoProposalPrefill) : undefined;
    (0,react.useEffect)(function() {
        if (!addSubDaoProposalPrefillHref) {
            return;
        }
        router.prefetch(addSubDaoProposalPrefillHref);
    }, [
        addSubDaoProposalPrefillHref,
        router
    ]);
    // Notify if parent has not yet added subDAO.
    (0,react.useEffect)(function() {
        if (daoInfo.parentDao && parentDaosSubDaosLoadable.state === "hasValue" && parentDaosSubDaosLoadable.contents && !parentDaosSubDaosLoadable.contents.some(function(param) {
            var addr = param.addr;
            return addr === daoInfo.coreAddress;
        })) {
            if (isMemberOfParent && addSubDaoProposalPrefillHref) {
                (0,react_hot_toast_esm/* default */.ZP)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "cursor-pointer transition-opacity hover:opacity-80 active:opacity-70",
                    onClick: function() {
                        return router.push(addSubDaoProposalPrefillHref);
                    },
                    children: [
                        t("info.subDaoNeedsAdding", {
                            parent: daoInfo.parentDao.name,
                            child: daoInfo.name
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "underline",
                            children: t("button.clickHereToProposeAdding")
                        })
                    ]
                }));
            } else {
                react_hot_toast_esm/* default.success */.ZP.success(t("info.subDaoNeedsAdding", {
                    parent: daoInfo.parentDao.name,
                    child: daoInfo.name
                }));
            }
        }
    }, [
        addSubDaoProposalPrefillHref,
        daoInfo.coreAddress,
        daoInfo.name,
        daoInfo.parentDao,
        encodedAddSubDaoProposalPrefill,
        isMemberOfParent,
        parentDaosSubDaosLoadable.contents,
        parentDaosSubDaosLoadable.state,
        router,
        t, 
    ]);
    var depositInfoSelectors = (0,react.useMemo)(function() {
        return daoInfo.proposalModules.map(function(proposalModule) {
            return (0,proposal_module_adapter/* matchAndLoadCommon */.gw)(proposalModule, {
                chainId: daoInfo.chainId,
                coreAddress: daoInfo.coreAddress
            }).selectors.depositInfo;
        });
    }, [
        daoInfo.chainId,
        daoInfo.coreAddress,
        daoInfo.proposalModules
    ]);
    var proposalModuleDepositInfosLoadable = (0,stateless/* useCachedLoadable */.VwH)((0,es/* waitForAll */.k9)(depositInfoSelectors));
    var maxProposalModuleDeposit = proposalModuleDepositInfosLoadable.state !== "hasValue" ? 0 : (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(proposalModuleDepositInfosLoadable.contents.filter(Boolean).map(function(param) {
        var amount = param.amount;
        return Number(amount);
    })).concat([
        0
    ]));
    var ref4 = (0,stateful/* usePinnedDaos */.wY)(), isPinned = ref4.isPinned, setPinned = ref4.setPinned, setUnpinned = ref4.setUnpinned;
    var pinned = isPinned(daoInfo.coreAddress);
    // Get payroll tab component, if exists.
    var PayrollTab = (ref = usePayrollAdapter()) === null || ref === void 0 ? void 0 : ref.PayrollTab;
    var ref5 = (0,react.useState)(false), showConfigureModal = ref5[0], setShowConfigureModal = ref5[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* DaoHome */.Yvj, {
                LinkWrapper: stateful/* LinkWrapper */.gM,
                SuspenseLoader: stateful/* SuspenseLoader */.yI,
                daoInfo: daoInfo,
                daoInfoBar: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* DaoInfoBar */.lw, {}),
                membersTab: MembersTab && /*#__PURE__*/ (0,jsx_runtime.jsx)(MembersTab, {}),
                onConfigure: function() {
                    return setShowConfigureModal(true);
                },
                onPin: function() {
                    return pinned ? setUnpinned(daoInfo.coreAddress) : setPinned(daoInfo.coreAddress);
                },
                payrollTab: PayrollTab && /*#__PURE__*/ (0,jsx_runtime.jsx)(PayrollTab, {}),
                pinned: pinned,
                proposalsTab: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* ProposalsTab */.hC, {}),
                rightSidebarContent: connected ? // If membership not yet loaded, show loading skeleton.
                isMember === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* ProfileDisconnectedCard */.$k, {
                    className: "animate-pulse"
                }) : isMember ? /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* ProfileMemberCard */.QSk, {
                    daoName: daoInfo.name,
                    membershipInfo: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* SuspenseLoader */.yI, {
                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Loader */.aNw, {
                            size: 24
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileCardMemberInfo, {
                            deposit: maxProposalModuleDeposit > 0 ? maxProposalModuleDeposit.toString() : undefined
                        })
                    }),
                    showUpdateProfileNft: updateProfileNft.toggle,
                    updateProfileName: updateProfileName,
                    walletProfile: walletProfile
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* ProfileNotMemberCard */.a4H, {
                    daoName: daoInfo.name,
                    membershipInfo: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* SuspenseLoader */.yI, {
                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateless/* Loader */.aNw, {
                            size: 24
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileCardMemberInfo, {
                            deposit: maxProposalModuleDeposit > 0 ? maxProposalModuleDeposit.toString() : undefined
                        })
                    }),
                    showUpdateProfileNft: updateProfileNft.toggle,
                    updateProfileName: updateProfileName,
                    walletProfile: walletProfile
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* ProfileDisconnectedCard */.$k, {}),
                subDaosTab: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* SubDaosTab */.WA, {}),
                treasuryAndNftsTab: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* TreasuryAndNftsTab */.di, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateful/* DiscordNotifierConfigureModal */.iM, {
                onClose: function() {
                    return setShowConfigureModal(false);
                },
                open: function() {
                    return setShowConfigureModal(true);
                },
                visible: showConfigureModal
            })
        ]
    });
};
var DaoHomePage = function(_param) /*#__PURE__*/ {
    var _ = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(stateful/* DaoPageWrapper */.zn, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerDaoHome, {})
    }));
};
var __N_SSG = true;
/* harmony default export */ var _address_ = (DaoHomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [702,774,888,179], function() { return __webpack_exec__(88160); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);